export default {
  globals: {
    order_status_breakdown: 'Uitsplitsing van de bestelstatus',
    items_created_vs_fulfilled: 'items gemaakt vs. vervuld',
    gps_only_cables: 'GPS-only kabel',
    cables: 'Kabels',
    boxes: 'Boxes',
    current_devices_status: "Huidige status van units",
    based_on_average_contract_length: "Op basis van gemiddelde contractduur",
    based_on_contract_duration: "Op basis van contractduur",
    sum: "Sum",
    past_range: "Vorige periode",
    scheduled_range: "Gepland bereik",
    invoices_sent: "Verzonden facturen",
    sold_devices: "Verkochte apparaten",
    new_customers: "Nieuwe klanten",
    new_orders: "Nieuwe bestellingen",
    past: "Vorige",
    new_inquiries: "Nieuwe offerte",
    highlights: "Hoogtepunten",
    value: "Waarde",
    merge: "Combineren",
    are_you_sure_you_want_to_delete_this_item: "Weet u zeker dat u dit item wilt verwijderen?",
    add_synatec_product: "Synatec-product toevoegen",
    synatec_products: "Sinatec producten",
    is_lease: "Is lease",
    is_device: "Is dongel",
    synatec_code: "Sinatec code",
    contr_dur: "Contractduur",
    fleet_size: "Aantal units",
    add_new_item: "Nieuwe item toevoegen",
    order_services: "Services bestellen",
    enable: "Activeren",
    all_permissions: "Alle rechten",
    brands: "Brands",
    reload: "Herladen",
    fieldtracker_reference: "Fieldtracker referentie",
    service: "Service",
    device_type: "Unittype",
    id: "ID",
    brand: "Brand",
    current: "Huidige",
    create_sold_event: "Verkoopgebeurtenis aanmaken",
    reload_device: "Unit opnieuw laden",
    events: "Evenementen",
    export_devices: "Units exporteren",
    stats: "Statistieken",
    import: "Importeren",
    all_devices: "Ale units",
    stock: "Stock",
    fulfilled: "Uitgevoerd",
    all_synatec_orders: "Alle Sinatec-bestellingen",
    all_installations: "Alle installaties",
    connection_status: "Verbindingsstatus",
    installation_type: "Installatietype",
    service_device: "Service-unit",
    service_devices: "Service-units",
    installation_form: "Installatieformulier",
    device_action: "Selecteer unit",
    billed: "Gefactureerd",
    data: "Data",
    to_be_billed: "Te factureren",
    all_services: "Alle services",
    service_type: "Servicetype",
    charge_again: "Opnieuw belasten",
    mollie_payments: "Mollie-betalingen",
    credit_this_invoice: "Factuur crediteren",
    resend: "Opnieuw verzenden",
    mark_as_paid: "Markeren als betaald",
    mollie_direct_debit: "Automatische incasso (Mollie)",
    first_page_preview: "Voorbeeld eerste pagina",
    audits: "Audits",
    refresh: "Vernieuwen",
    invoice_type: "Factuur type",
    import_exact_parking: "Exact parkeren importeren",
    debiteur_no: "Debiteur no.",
    from_debiteur_no: "Van debiteur no.",
    from_invoice_no: "Van factuur no.",
    select_export_option: "Selecteer exportoptie",
    select_month: "Selecteer maand",
    internal_notes: "Interne aantekeningen",
    total_price_no_vat: "excl. BTW",
    import_exact: "Exact importeren",
    export_exact: "Exact exporteren",
    parking_invoices: "Parkeerfacturen",
    manual: "Manueel",
    new: "Nieuw",
    send_to: "Versturen naar",
    request_separate_install: "Aparte installatie aanvragen",
    request_install: "Installatie aanvragen",
    request_separate_service_call: "Aparte serviceoproep aanvragen",
    selected_devices: "Geselecteerde unit",
    request_separate_replace: "Aparte vervanging aanvragen",
    request_service_call: "Serviceoproep aanvragen",
    contact_information: "Contactinformatie",
    reason: "Reden",
    select_device: "Selecteer unit",
    request_replace: "Vervanging aanvragen",
    separate_service_call: "Aparte serviceoproep",
    separate_replace: "Aparte vervanging",
    separate_install: "Aparte installatie",
    install: "Installeren",
    service_call: "Serviceoproep",
    replacement: "Vervanging",
    needs_to_be_billed: "Moet worden gefactureerd",
    select_agent: "Selecteer agent",
    sold_at: "Verkocht bij",
    add_a_sold_event_for_these_devices: "Een verkoopgebeurtenis toevoegen voor deze apparaten",
    add_devices_from_stock: "Apparaten uit voorraad toevoegen",
    batch: "Batch",
    add: "Toevoegen",
    lease: "Lease",
    scheduled_invoices: "Geplande facturen",
    select_company: "Selecteer bedrijf",
    po_number: "Inkoopordernummer",
    click_on_inquiry_redirect: "Klik op aanvraag om door te sturen",
    show: "Tonen",
    canceled: "Geannuleerd",
    terminated: "Beëindigd",
    terminate: "Beëindigen",
    terminate_order: "Bestelling beëindigen",
    terminate_all_devices_warning: "Alle ACTIEVE apparaten worden beëindigd!",
    termination_reason: "Reden van beëindiging",
    download: "Download",
    orders_export: "Bestellingen exporteren",
    agent: "Agent",
    agents: "Agents",
    clear_filters: "Filters wissen",
    select_range: "Selecteer bereik",
    select_date_range_to_export: "Selecteer datumbereik om te exporteren",
    new_price: "Nieuwe prijs",
    installations: "Installaties",
    service_service: "Dienst",
    item_name: "Itemnaam",
    devices_action: "Actie voor apparaten",
    now: "Nu",
    cancell_order: "Bestelling annuleren",
    change_price_from: "Prijs wijzigen van",
    exact_code: "Exact code",
    kpi_type: "KPI-type",
    hard_delete: "Permanent verwijderen",
    change_agent: "Agent wijzigen",
    change_payment_type: "Betaalwijze wijzigen",
    customers_merge: "Klant samenvoegen",
    date_created: "Aanmaakdatum",
    items: "Producten",
    cancel_order: "Bestelling annuleren",
    order: "Bestelling",
    left_unchecked_pending: "Als dit leeg blijft (niet aangevinkt), wordt de aanvraag teruggezet naar de status ‘in behandeling’.",
    delete_also_inquiry: "Verwijder ook offerta",
    change_quantity_from: "Hoeveelheid wijzigen van",
    new_quantity: "Nieuwe hoeveelheid",
    quantity_short: "Hoeve.",
    status: "Status",
    import_tool: "Importeer",
    vat_price: "BTW",
    services_services: "Services",
    no_synatec_orders_found: "Geen Synatec-bestelling gevonden",
    synatec_orders: "Sinatec bestelt",
    create_synatec_order: "Bestelling creer Sinatec",
    schedule_at: "Gepland om",
    total_price: "Totale prijs",
    no_invoices_found: "Geen facturen gevonden",
    no_scheduled_invoices_found: "Geen geplande facturen gevonde",
    sent_to: "Verzonden naar",
    paid: "Betaald",
    not_paid: "Niet betaald",
    per_page: "Per pagina",
    show_pdf: "toon .pdf",
    type: "Type",
    warranty: "Garantie",
    assembly: "Montage",
    request_service: "Dienst aanvragen",
    request_fieldtracker_service: "Dienst aanvragen fieldtracker",
    re_sent_at: "Opnieuw",
    sent_at: "Verstuurd op",
    order_no: "Order nr.",
    invoice_no: "Factuur nr.",
    total_value: "Contract waarde",
    first_payment: "Eerste betaling",
    non_applicable: "Niet van toepassing",
    creation_date: "Aangemaakt op",
    direct_debit_exact: "automatische incasso (Exact)",
    direct_debit_mollie: "automatische incasso (Mollie)",
    half_year: "Half jaar",
    currency: "Currency",
    including_btw: "incl. BTW",
    vat: "BTW",
    value_no_vat: "excl. BTW",
    discount: "Korting",
    contract: "Contract",
    send_invoices: "Facturen sturen",
    more: "Meer",
    approve: "Goedkeuren",
    inquiry: "Offerte",
    units: "Units",
    close: "Sluit",
    view_audits: "Bekijk audits",
    synatec_orders_export: "Sinatec bestelt export",
    no_devices_found: "No devices found",
    confirmed: "Bevestigd",
    search_for: "Zoeken naar",
    sent_from: "Van",
    webshop_items: "Webshop producten",
    all_items: "All producten",
    page: "page",
    of: "of",
    resolved: "opgelost",
    no_results: "geen resultaten",
    showing: "tonen",
    arr: "ARR",
    user_already_added_to_company: "User already added to company",
    my_trips: "Mijn trips",
    trip_distance: "Aantal afstand",
    ask_for_certificate: "Vraag een certificaat aan via support@ulu.io",
    assign_a_driver: "Wijs een berijder toe",
    assigned: "Toegewezen",
    assign_new: "Toewijzen van nieuwe",
    all_drivers_score: "Alle berijders scores",
    contact_phone: "Contact telefoon",
    include_trips: "Omvatten trips",
    include_trips_exports_only: "Omvatten trips ( alleen export )",
    trip_scores: "Mijn score",
    include_trips_excel_only: "Omvatten trips",
    score: "Score",
    resend_invitation: "Resend invitation",
    vehicle_status: "Voertuig informatie",
    trip_date: "Rit datum",
    dashboard: "Dashboard",
    user_successfully_created:
      "Het registreren is gelukt! Er is een email naar je gestuurd met informatie over de vervolgstappen!",
    recall_device: "Terugroepen apparaat",
    speeding_percent: "% te hard gereden",
    this_vehicle_has_no_error_history:
      "Dit voertuig heeft geen probleem codes gehad",
    user_info: "Jouw gegevens",
    disable: "Uitschakelen",
    enter_postal_code: "Voer postcode in",
    enter_imei: "Vul het dongelnummer in (IMEI)",
    enter_lastname: "Voer achternaam in",
    no_rights_for_trip: "You have no right to view this trip",
    company_cant_switch_owner_company:
      "Company cant change owner to other company",
    user_cant_switch_owner_user: "User cant change user owner of vehicle",
    no_rights_for_company: "No rights to view company",
    no_rights_for_user: "You have no right to view this user",
    enter_password_confirmation: "Herhaal wachtwoord",
    register: "Voer imei",
    walking: "lopen",
    email_verification_verified: "Account is al geverifieerd.",
    no_rights_for_vehicle: "You have no right to view this vehicle",
    user_not_in_company: "User not a part of given company",
    delete_vehicle_confirmation:
      "Indien je het voertuig verwijdert, worden alle gegevens van dit voertuig gewist. Weet je het zeker?",
    enable_keurmerk_confirmation:
      "Bevestig om het Keurmerk in te schakelen voor dit voertuig. Alleen de ritten die van nu af aan gemaakt worden zullen opgenomen worden in het Keurmerk verslag. Er is geen optie om het Keurmerk van dit voertuig uit te schakelen als het eenmaal is ingeschakeld. Weet je het zeker?",
    company_info: "Bedrijfsinformatie",
    private_user: "Privé",
    email_verification_expired: "Email verification link expired.",
    user_not_part_of_company: "User is not a part of your company",
    delete_user: "Verwijder gebruiker",
    enter_company_name: "Bedrijfsnaam",
    enter_city: "Voer stad",
    enter_firstname: "Voer voornaam",
    first_order: "Eerste order",
    contract_details: "Contract details",
    shared_web_app_id_detected: "Gedeelde web app ID gedetecteerd",
    used_as_default: "Gebruikt als standaard",
    not_used_as_default: "Niet gebruikt als standaard",
    contract_type: "Type van contract",
    contract_termination_policy: "Beëindigingsbeleid van contract",
    custom_order_item: "Aangepast orderitem",
    no_billing_item: "Geen factuuritem",
    info_from_orders: "Informatie uit bestellingen",
    monthly_price: "Maandelijkse prijs",
    price_reason_ambiguous_line: "Meerdere orderregels komen overeen met dit apparaat, waardoor de prijs niet bepaald kon worden",
    price_reason_calculation_error: "Er is een fout opgetreden bij het berekenen van de prijs",
    price_reason_unknown: "De prijs kon niet bepaald worden",
    submit: "Registreren",
    enter_phone: "Voer telefoon in",
    company: "Zakelijk",
    include_trips_in_export: "Inclusief alle ritten",
    unit_system: "KM/H of Miles/H",
    allow: "Toestaan",
    purchased_devices: "Dongel nummer",
    save: "Opslaan",
    service_on: "Service op datum",
    i_agree_with_terms_and_conditions: "Ik ga akkoord met de voorwaarden",
    find_a_company: "Zoek een bedrijf",
    no_devices: "Geen dongel nummer? Neem contact met ons op.",
    transfer_ownership: "Voeg de dongel toe aan je bedrijf",
    add_to_company: "Voeg toe aan bedrijf",
    make_a_password: "Maak een wachtwoord aan",
    odometer_trigger_on: "Service op kilometer ",
    find_a_dongle: "zoek jouw dongel",
    no_rights_for_mobile_device: "You have no right to view this mobile device",
    no_rights_for_company_user: "No rights to view company user",
    no_rights_for_notification: "You have no right to view this notification",
    role: "Rol",
    region: "Regio",
    allow_access: "Toegang verlenen",
    owner_id: "Bezitter",
    zip_code: "Postcode",
    company_user_company_select_text:
      "Selecteer een bedrijf of creëer een privé gebruiker",
    trip_duration: "Rittijd",
    phone: "Telefoon",
    yes: "Ja",
    top_speed: "Topsnelheid",
    engine_type: "Brandstof",
    switch_role: "Verander rol",
    log_in_as_user: "Log in als gebruiker:",
    reconnect_the_dongle: "Opnieuw aansluiten",
    registration_type: "Type kenteken",
    trip_has_no_geo_points:
      "Deze trip heeft geen geregistreerde GPS coördinaten. ",
    no: "Nee",
    power: "Vermogen",
    disconnected: "Niet aangesloten",
    vehicle_service_content:
      "Voertuig onderhoud notificatie zal %{days} dagen voor het verstrijken van de einddatum of %{distance} kilometer voor de opgegeven kilometerstand een melding geven",
    has_errors: "Foutmeldingen",
    reports: "Rapportages ",
    mark_all_as_read: "Alles markeren als gelezen",
    model_series: "Model",
    year: "Jaar",
    empty: "Leeg",
    enter_new_password: "Voer nieuw wachtwoord in",
    first: "Eerst",
    change_ownership_of_devices: "Wijzig eigenaar van dongels",
    search: "Zoek",
    search_status: "Zoek status",
    trips: "Ritten",
    private: "Privé",
    firstname: "Voornaam",
    max_rpm: "Max toerental",
    distance: "Afstand",
    driver_score: "Rijscore",
    hexa_color: "HEXA kleur",
    vehicle: "Voertuig",
    errors: "Foutmeldingen",
    services: "Onderhoud",
    no_errors: "Geen foutmeldingen",
    reconnect: "Opnieuw aansluiten",
    enable_keurmerk: "Keurmerk",
    assign_owner_to_different_user:
      "Een andere eigenaar toewijzen aan deze auto",
    owner_also_driver: "Eigenaar van het voertuig is ook de bestuurder",
    click_to_enable: "Klik om te activeren",
    change_name: "Naam veranderen",
    vin: "Chassisnummer (VIN)",
    click_to_disable: "Klik om uit te schakelen",
    registered_on: "Geregistreerd",
    modelyear: "Bouwjaar",
    reg_type: "Type kenteken",
    set_new: "Wijzig %{type}",
    vehicle_owner_details: "Voertuig eigenaar details",
    limited_information_display: "Beperkte informatie",
    power_metric: "PK",
    my_score: "Mijn score",
    next_page: "Volgende pagina",
    invited_on: "Toegevoegd",
    fiscal_status_code: "Fiscale status",
    vehicle_and_trips_privacy: "Voertuig en trip modus  ",
    user_with_email_not_found: "User not found",
    fuel_level: "Brandstof niveau",
    good: "Goed",
    parked: "Geparkeerd",
    moving: "Onderweg",
    change_ownership_to: "Wijzig eigenaar naar %{owner_name}",
    commute: "Woon-werk",
    company_permissions: "Rechten",
    company_user: "Gebruiker",
    reg_country: "Land",
    current_filters: "Huidige filters",
    enter_old_password: "Voer oud wachtwoord in",
    equals: "Gelijk aan",
    total_distance: "Totaal gereden afstand",
    total_duration: "Totaal in de auto gezeten",
    trip_count: "Aantal ritten",
    no_employee: "Geen werknemer (bijv. zelfstandig ondernemer)",
    log_in_as_company: "Log in als bedrijf",
    private_trip: "Deze rit is privé",
    private_trip_limited: "Informatie over deze rit is beperkt.",
    login_as: "Login as",
    notice: "Notice",
    action: "Actie",
    about_ulu: "Over ULU",
    action_label: "Actie label",
    trip: "Rit",
    odometer_correction_successfull: "Kilometerstand succesvol aangepast!",
    device_owner_id: "Dongel eigenaar ID",
    manage: "Beheren",
    disconnect_dongle: "Dongel loskoppelen",
    lastname: "Achternaam",
    of_the_vehicle: "van het voertuig",
    delete_vehicle: "Voertuig verwijderen",
    demo_mode: "Demo mode",
    device_owner_type: "Dongel eigenaar type",
    vehicle_details: "Voertuig details",
    email: "E-mail",
    cc_email: "CC E-mail",
    lost_connection: "Verbinding verbroken",
    mark_as_completed: "Afgerond",
    trip_details: "Details",
    trip_information: "Algemeen",
    current_errors: "Huidige foutmeldingen",
    error_history: "Geschiedenis foutmeldingen ",
    occured_on: "Ontstaan op",
    cleared_on: "Gewist op",
    active_since: "Actief vanaf",
    trip_start: "Rit start",
    trip_stop: "Rit einde",
    all: "Alles",
    all_trips: "Alle ritten",
    all_vehicles: "Alle voertuigen",
    average_speed: "Gemiddelde snelheid",
    battery: "Accu",
    battery_level: "Accu spanning",
    worst_score_first: "Slechtste score",
    max_speed_first: "Hoogste snelheid ",
    max_distance_first: "Meeste km's",
    apply: "Toepassen",
    are_you_sure: "Weet u het zeker?",
    average: "Gemiddelde",
    average_score: "Gemiddelde score",
    birthday: "Geboortedatum",
    max_rpm_first: "Hoogste toerental",
    not_available: "n.b.",
    business: "Zakelijk",
    city: "Woonplaats",
    today_trips: "Ritten vandaag",
    todays_max_speed: "Maximale snelheid vandaag",
    change_password: "Wachtwoord wijzigen",
    vehicle_errors: "Meldingen",
    vehicles: "Voertuigen",
    todays_distance: "Afstand vandaag",
    vehicle_mode: "Status",
    body_type: "Voertuigsoort",
    "30_days_ago_odometer_update_description":
      "30 dagen geleden kilometerstand aangepast",
    driving: "Onderweg",
    company_id: "Bedrijf ID",
    contains: "Bevat",
    about_x_hours: "Ongeveer x uur",
    admin: "Beheer",
    notified_at: "Meegedeeld op: %{time}",
    any: "Een",
    assign_driver_to_vehicle: "Berijder toewijzen aan deze auto",
    cancel: "Annuleren",
    country: "Land",
    company_information: "Bedrijfsinformatie",
    color: "Kleur",
    contact_us: "Neem contact met ons op",
    administrator_information: "Beheerders informatie",
    application_type: "Applicatie type",
    back_to_my_session: "Terug naar mijn sessie",
    basic_information: "Basis informatie",
    business_gray: "Zakelijk grijs",
    device: "Dongel",
    english: "Engels",
    hour: "uur",
    delete_confirmation: "Weet je zeker dat je deze informatie wilt wissen?",
    less_than: "minder dan",
    facebook: "Facebook",
    imei: "IMEI",
    danger_zone: "Pas op!",
    date_to: "Datum tot",
    create: "Creëer",
    clear: "Wis",
    cleared_at: "Gewist op",
    code: "Code",
    companies: "Bedrijven",
    confirm_new_password: "Bevestig nieuw wachtwoord",
    current_odometer: "Huidige kilometerstand",
    default_trip_type: "Standaard rit soort",
    device_id: "Dongel identificatie nummer",
    ends_with: "Eindigt met",
    enter_name: "Voer naam in",
    enter_password: "Voer wachtwoord in",
    filter: "Filter",
    filters: "Filters",
    overview: "Overzicht",
    created_at: "Gecreëerd op",
    fieldtracker_task_name: "FT taak",
    blog: "Blog",
    comments: "Opmerkingen",
    companies_dongles: "Dongels",
    confirm_delete: "Wis object?",
    current_driver: "Huidige berijder",
    day: "Dag",
    deleted: "Verwijderd",
    delete_model: "Verwijder model",
    delete: "Verwijderen",
    device_imei: "IMEI nummer dongel",
    last_position: "Laatste positie",
    enter_sex: "Geslacht",
    pending: "Uitnodiging verstuurd",
    house_number: "Huisnummer",
    month: "maand",
    language: "Taal",
    details: "Details",
    make: "Merk",
    max_speed: "Max snelheid",
    minute: "Minuut",
    more_menu: "Meer",
    notifications: "Meldingen",
    delete_user_confirmation:
      "Weet u zeker dat u deze gebruiker wilt verwijderen?",
    date_from: "Datum vanaf",
    contact_email: "Contact e-mail",
    contact_name: "Contact naam",
    deviant_route: "Afwijkende route",
    deviant_route_distance: "Afstand afwijkende route",
    specifications: "Specificaties",
    housenumber: "Huisnummer",
    logged_as: "Ingelogd als",
    logout: "Uitloggen",
    edit: "Wijzig",
    address: "Adres",
    log_in: "Aanmelden",
    find_a_vehicle: "Vind een voertuig",
    privacy: "Rit type",
    history: "Overzicht",
    next_service: "Volgende onderhoudsbeurt",
    last_service_on: "Laatste onderhoud",
    disconnect: "Loskoppelen",
    vehicle_id: "Voertuig",
    trip_type: "Ritmodus",
    total_trip_count: "Totaal aantal ritten",
    total_score: "Gemiddelde score",
    csv_data_export: "CSV rapportage",
    excel_data_export: "Excel rapportage",
    obd_odometer: "Uitgelezen kilometerstand",
    odometer: "Huidige kilometerstand",
    find_user: "Zoek berijder",
    mark_as_pending: "Markeer als wachtend",
    odometer_in_km: "Kilometerstand in km's",
    login: "Aanmelden",
    sign_in: "Inloggen",
    waiting: "Wachten op connectie",
    users: "Gebruikers",
    completed_at: "Afgerond",
    completed: "Voltooid",
    update_odometer: "bijwerken kilometerteller",
    total_distances_since_last_correction:
      "Totale afstand sinds de laatste correctie",
    calculation_time_since: "Berekende tijd sinds",
    new_odometer_value: "Nieuwe kilometerstand",
    updating_the_odometer_content:
      "Door het updaten van de kilometerteller zal er een correctie rit met proportionele waardes, sinds de laatste correctie of vanaf het begin van het huidige jaar, van zakelijk, woon-werk en privé kilometers plaats vinden. ",
    correction_trip_information: "Gecorrigeerde rit informatie",
    total_correction_distance: "Totale correctie afstand",
    license_plate: "Kenteken",
    notes: "Aantekeningen",
    bsn: "BSN",
    next_service_predicted_on: "Volgende onderhoudsbeurt verwacht op",
    next_service_on: "Volgende onderhoud op/bij",
    next_vehicle_inspection_date: "Afloop APK",
    first_odometer_input_content: "Plaats kilometerstand",
    generate_xml_for_year: "Genereren van een keurmerk XML voor het jaar",
    generate: "Genereren",
    file_name: "bestandsnaam",
    export_status: "Status export",
    owner: "Eigenaar",
    odometer_correction: "Kilometerteller correctie",
    odometer_in_: "Kilometerstand in %{unit}",
    device_mantainer_recall_text:
      "Door de dongel terug te roepen zal deze worden losgekoppeld van de huidige auto ( indien aanwezig) en verwijderd uit %{company_name} vloot",
    vehicle_works_great: "Voertuig werkt goed, er zijn geen foutmeldingen",
    create_new_point_of_interest: "Maak een nieuwe Nuttige Plaats (NP) aan",
    fuel_usage: "Brandstofverbruik",
    fuel_cost: "Brandstofkosten",
    add_user: "Voeg een gebruiker toe",
    trip_costs_per_100: "Kosten per 100 km",
    no_transaction_costs: "Geen transactiekosten",
    fueling_details: "Brandstof details",
    forgot_password: "Wachtwoord vergeten",
    not_required: "Niet verplicht",
    company_has_devices_cant_delete:
      "Er zijn dongels actief; op dit moment kan je het niets verwijderen",
    make_group_admin: "Maak gebruiker ook groepsadmin",
    edit_group: "Bewerk groep",
    company_users: "Gebruikers",
    enter_email: "Vul hier je email adres in",
    poi_type: "NP type",
    add_groups: "Voeg gebruiker aan een groep toe",
    odometer_stop: "Kilometerstand (stop)",
    password_reset: "Wachtwoord resetten",
    reset_password: "Wachtwoord vergeten",
    password_reset_success:
      "De link om je wachtwoord te resetten is verstuurd naar je email adres.",
    password_reset_expired:
      "De link om je wachtwoord te resetten is verlopen of de gebruiker is niet bekend.",
    incompatible_browser:
      "Sorry, je browser werkt helaas niet met ULU. Via deze link je jou browser upgraden %{link1} of %{link2}.",
    name: "Naam",
    road_country: "Land",
    road_region: "Regio",
    road_place: "Plaats",
    road_zip_code: "Postcode",
    road_house_number: "Huisnummer",
    road_name: "Straatnaam",
    street_name: "Straatnaam",
    your_email: "Je email adres",
    password: "Wachtwoord",
    osm_road_name: "OSM Straatnaam",
    create_new_poi: "Voeg een nuttige plaats toe",
    poi_detection_within_radius: "NP herkenning in een straal van (meters)",
    start_road_name: "Straatnaam",
    company_has_vehicles_cant_delete:
      "Dit bedrijf heeft nog voertuigen, verwijder eerste deze voertuigen",
    start_road_place: "Plaats",
    start_road_country: "Land",
    start_road_house_number: "Huisnummer",
    trip_stop_information: "Trip stop informatie",
    stop_road_house_number: "Huisnummer",
    stop_road_name: "Straatnaam",
    company_has_companies_cant_delete:
      "Dit bedrijf heeft nog andere bedrijven aangesloten, verwijder eerst deze bedrijven",
    create_new_group: "Maak een nieuwe groep aan",
    search_user_or_vehicle: "Zoek gebruiker of voertuig",
    remove: "Verwijder",
    nearest_parking_origin_search_text: "Dichtstbijzijnde zone",
    companu_users_permission: "Rechten voor gebruikers (bedrijf)",
    order_compeleted_description:
      "Bedankt voor de bestelling! Wij zullen de dongels z.s.m. opsturen! Mocht je nog vragen hebben, let us know!",
    devices_orderd: "Devices besteld",
    paid_with_mollie: "Betaald met Mollie",
    order_completed: "Bestelling gelukt!",
    faq_3_description:
      "ULU verzamelt gegevens die noodzakelijk zijn voor het functioneren van de dienst. Dit is informatie afkomstig uit je voertuig, inclusief locatie-gebaseerde informatie, voertuig(technische) informatie en gegevens over rijgedrag. We gebruiken deze gegevens voor:\r\n<br/>\r\n<br/>\r\n<ul>\r\n<li>Het aanbieden van mobiliteitsdiensten via je smartphone en web-portal.</li>\r\n<li>Het verbeteren en verder ontwikkelen van de services.</li>\r\n</ul>",
    faq_8_description:
      "Ja, je kunt meerdere dongels aanschaffen voor extra auto’s en je kunt deze zien op één account. Voeg hiervoor het serienummer van de desbetreffende dongels toe in je ULU account.",
    start_road_region: "Regio",
    start_road_zip_code: "Postcode",
    trip_start_information: "Trip start informatie",
    stop_road_region: "Regio",
    trip_type_id: "Ritmodus",
    at: "om",
    edit_trip: "Wijzig rit",
    update_trip: "Update rit",
    edit_poi: "Wijzig NP",
    release_notes:
      "<br>7.6.2017 <br><div>- Vehicles - added a field to add notes on the vehicle</div>\r\n<br>6.6.2017 <br><div>- Reports - switch between driver and vehicle statistics</div><div>- Fuel events - create custom fuel events or integrate travelcard to create them automatically (under vehicle details). For integrating Travelcard please contact info@ulu.io</div><div>- If Fuel events exists trips each trip gets a price (how much does it cost)</div><div>- Enable/disable Set POI as Start of trip or End of trip </div><div>- Enable/disable Set Default trip privacy type as Business </div><div>- Enable/disable Set Trip privacy type based on POI. This option automatically updates the privacy of a trip if for example: it started on a private point of interest and ended on a business one </div><br>\r\n<br>26.5.2017 <br><div>- Maintainer can now export the vehicles in the view</div><div>- Change dashboard between license plate / driver name / vehicle name.\r\n Works only for companies. Can be changed in the company details.</div><br>\r\n<br>15.5.2017 <br><div>- All trips renamed to history to display Travelcard and parking (coming soon) events</div><div>-Points of interest accessible to everyone</div><br>\r\n<br>5.4.2017 <br><div>- Added simple api overview for companies. For more info contact info@ulu.io.</div><br>\r\n<br>20.3.2017 <br><div>- Added functionality to map (by clicking on the icon near the search field) to search and focus on places and areas.</div><br>\r\n<br>13.3.2017 <br><div>- Added traffic layer on map.</div><br>\r\n<br>10.2.2017 <br><div>- Added car sharing option for companies. For more info contact info@ulu.io.<div><br>\r\n<br>10.1.2017 <br><div>- Faq.<div>- Add device from account&nbsp;</div><div>- Select drivers from company - autocomplete email form&nbsp;</div><div>- notifications center - edit which notifications are comming on a company level or on each specific vehicle level&nbsp;</div><div>- other bug fixes<br>\r\n<br>25.11.2016 <br>- On map vehicle icons changed to license plates.<div>- Checkbox to enable live view of vehicles&nbsp;</div><div>- Vehicle and privacy on vehicle details changed to settings&nbsp;</div><div>- enable switch role from company to another company&nbsp;</div><div>- added pencile on editable fields<br>\r\n<br>15.11.2016 <br>- Keurmerk users: dont allow to generate certificate if data is missing or not correct. Allow to update make and model on vehicle.<br>\r\n<br>12.11.2016 <br>- Keurmerk users: button to get previous/next trip location data on edit trip. Private trip text on trips display limited informations.<br>\r\n<br>25.10.2016 <br>- Switch user refresh design, display invoices for users, maintainer sorting (by clicking on the column name) <br>\r\n<br>12.8.2016 <br>- Trip cards display refresh (added times, avg speed, removed rpm, max speed displayed only on screens bigger than 1600px wide) <br>\r\n<br>8.8.2016 <br>- Keurmerk: Add to vehicle even after vehicle is created (in vehicle details). If company allowed for Keurmerk select if Keurmerk or not for vehicle. Single user Keurmerk view <br>\r\n<br>4.8.2016 <br>- On vehicle display score and trip number based on user (and not global). Fixed bug on reports <br>\r\n<br>25.7.2016 <br>- Hide trips with distance 0 <br>\r\n<br>24.7.2016 <br>- Fixed error causing mobile application dates with am and pm to not return trip data <br>\r\n<br>30.6.2016 <br>- New user update odometer fix. Added vehicle inspection date to vehicle and maintainer <br>\r\n<br>23.6.2016 <br>- Excel and csv display all trips and vehicles for selected time period <br>\r\n<br>17.6.2016 <br>- New dongle purchase registration <br>\r\n<br>8.6.2016 <br>- Added Switch between imperial and metric systems (miles vs km) <br>\r\n<br>6.6.2016 <br>- Added Dutch language <br>\r\n<br>11.5.2016 <br>- Event triggers for vehicle on and vehicle off - BETA <br>\r\n<br>20.4.2016 <br>- Event triggers for start and stop trip - BETA<br>\r\n<br>13.4.2016 <br>- Mobile touch icons added <br>\r\n<br>12.4.2016 <br>- Allow partner companies to have custom metadata,... <br>\r\n<br>21.3.2016 <br>- Live update of map (without the need to refresh) <br>\r\n<br>4.3.2016 <br>- Bug fix - Don't display vehicle on map if vehicle in private mode <br>\r\n<br>21.1.2016 <br>- Maintainer - transfer owner of device<br>\r\n<br>19.1.2016 <br>-  Add radius on point of interest, add point of intereset to reports<br>\r\n<br>7.1.2016 <br>- Additional fields for editing of company settings, edit user profile (Click on user icon), notifications displayed also to drivers, Keurmerk support<br>\r\n<br>12.10.2015 <br>- Change excel and csv export times from am/pm to 24 hour<br>\r\n<br>13.10.2015 <br>- Added notifications: If dongle plugged into vehicle, if firmware on device updated and if low battery on vehicle<br>\r\n<br>14.10.2015 <br>- Notifications displayed also to drivers<br>\r\n<br>25.10.2015 <br>- Add raw datetime to exports<br>\r\n<br>26.10.2015<br>-  Sorting issue fixed on reports<br>\r\n<br>14.12.2015 <br>- Change password api call<br>\r\n<br>15.10.2015<br>- Notifications<br><br>24.8.2015<br>- Location of the vehicle in private mode is not visible to fleet owner. <br>- Filters on vehicle list<br><br>24.8.2015<br>- Location of the vehicle in private mode is not visible to fleet owner. <br>- Removal of vehicles with errors and services on the dashboard overview<br><br>18.8.2015<br>- Page speed optimizations<br><br>6.8.2015<br>- Beside ownership of the car, users can now very easily specify the driver of each vehicle<br>- upgraded add vehicle screen. Users can now easily specify the owner and the driver of the vehicle<br><br>28.7.2015<br>- updated api, more about it in the documentation<br>- updated data retrieval from license plates (for cars from the Netherlands)<br><br>27.7.2015<br>- updated api, more about it in the documentation<br><br>21.7.2015<br>- additional api calls: company_user<br>- added trip_no to api call<br>- backend scale up (the transition should be invisible, but if you detect anything unusual, please let us know by sending an email to support@ulu.io)<br><br>13.7.2015<br>- display driver on vehicle screen<br>- fix error displaying if user verification link expired or already accepted<br><br>12.7.2015<br>- use same link when resending user invitation<br><br>10.7.2015<br>- added changing of trip types on vehicle<br><br>8.7.2015<br>- delete user option on user view<br><br>1.7.2015<br>- added timezones to user<br>- delete vehicle api call<br><br>25.6.2015<br>- blog added on blog.ulu.io<br>- added links to blog in page footer<br>- image upload fix <br><br>23.6.2015<br>- allow - in license plates<br>- fixed vehicle permission display<br><br>22.6.2015<br>- expiration date on user invitation changed from 2 hours to 7 days<br><br>20.6.2015<br>- added Namens to user email sending (if company allowed to send emails)<br><br>18.6.2015<br>- fixed crash if old invitation clicked<br>- added display of electric distance on trip<br>- display obd odometer on vehicle if exists<br><br>17.6.2015<br>- resend user invitation on owner<br>- removed hours from time on invite display<br><br>15.6.2015<br>- resend user invitation<br><br>12.6.2015<br>- user invitation to fleet from users view<br><br>10.6.2015<br>- added custom fields to models<br><br>9.6.2015<br>- fixed IE error, that did not allow to login<br><br>3.6.2015<br>- owner invitation<br>- disconnect vehicle<br><br>1.6.2015<br>- updated score, not counting short trips without score<br><br>29.5.2015<br>- privacy changed. Some trips may not appear. If this happens please let us know.<br>- Mail sending changed<br><br>5.5.2015<br>- trips merging<br>- optimized tables for trip_points and trips<br><br>23.4.2015<br>- site optimization for mobile phones<br><br>16.4.2015<br>- added commute to business/private<br>- display private/business/commute trips depending on user roles <br><br>13.4.2015<br>- added timezone to vehicle adding<br>- work with difference timezones during trip<br><br>9.4.2015<br>- reports version 1.0<br>- location display removed from leasing view<br>- mobile app api for time defined statistics<br><br>3.4.2015<br>- updating reports, some features may not be working<br>- switched to new backend for better data accuracy. Some historical trips may merge or not be present. For any question please contact our support email.<br>- all country's are now supported<br><br>27.3.2015<br>- push notifications for missing vehicle heartbeats<br><br>26.3.2015<br>- fixed issue with email sending (emails were not sent)<br>- updated vehicle creation <br><br>12.3.2015<br>- simpified way to add new user to a vehicle (on vehicle create)<br><br>10.3.2015<br>- facebook and google login<br>- logout<br>- fleet admin and insurance different frontend<br>- single user login (single user can login and see the vehicle)<br>- reports (trip view) sorting<br>- Added support for new country's: (North America - State Texas, India, Australia,<br>South Africa)<br><br><br></div>",
    liters: "Liters",
    quantity_in_liters: "Hoeveelheid in liters",
    company_has_users_cant_delete:
      "Dit bedrijf heeft nog gebruikers. Verwijder eerst deze gebruikers",
    poi_address_update: "Stel NP in als begin- of eindpunt van de reis",
    trips_always_business: "Stel 'zakelijk' in als standaard ritmodus",
    time: "Tijd",
    pick_a_color: "Kies een kleur voor de groep",
    show_closest_vehicles: "Bekijk de dichtstbijzijnde auto's",
    avg_time_per_visit: "Gem. tijd per bezoek",
    duration_time: "Tijdsduur",
    fuel_type: "Brandstoftype",
    switch_vehicle_to_business_after_trip:
      "Switch naar zakelijke-modus na de rit",
    switch_vehicle_to_private_after_trip: "Switch naar privé-modus na de rit",
    allow_login_as: "Sta 'login als' toe",
    premiumdiesel: "Premium Diesel",
    diesel: "Diesel",
    company_successfully_updated: "Bedrijf succesvol bijgewerkt",
    vehicles_info: "Voertuig informatie",
    all_users: "Alle gebruikers",
    include_poi_into_explanation:
      "De Nuttige Plaats (NP) wordt toegevoegd aan desbetreffend bedrijf / gebruiker. In het geval van een bedrijf, zal de Nuttige Plaats voor iedere bestuurder beschikbaar zijn.",
    device_owner: "Eigenaar hardware",
    parking_details: "Parkeer details",
    entity: "Entiteit",
    is_geofence_notify_out: "Schakel Geofence notificatie uit",
    is_point_of_interest: "Nuttige Plaats",
    permissions: "Rechten",
    create_new_company_with_keurmerk: "Maak een nieuwe bedrijf aan (keurmerk)",
    delete_company_confirmation:
      "Weet je zeker dat je dit bedrijf wilt verwijderen?",
    notifications_permission: "Rechten voor notificaties",
    vehicles_permission: "Rechten voor voertuigen",
    test: "Test",
    edit_driver_id: "Wijzig berijder ID",
    create_companies: "Creëer bedrijven",
    delete_company_users: "Verwijder gebruikers van bedrijf",
    view_privacy_filters: "Bekijk privacy filters",
    stop_road_country: "Land",
    stop_road_place: "Plaats",
    stop_road_zip_code: "Postcode",
    show_trip: "Rit weergaven",
    distance_electric: "Afstand elektrisch",
    usage: "\r\nVerbruik",
    start_location: "Start locatie",
    all_drivers: "Alle berijders",
    trip_privacy_based_on_poi: "Stel ritmodus in o.b.v. NP",
    average_time_per_visit: "Tijd per bezoek",
    pois: "NP 's",
    number_of_visits: "Aantal keer bezocht",
    poi_address_update_explanation: "Verklaring update NP-adres",
    trips_always_business_explanation: "Verklaring ritten altijd zakelijk",
    unit_price: "Prijs per stuk",
    callback_url_not_valid_description: "URL niet geldig",
    deny: "Weiger",
    poi_automatic_trip_classification: "Automatische ritmodus",
    thank_you_for_the_order: "Bedankt voor de bestelling!",
    order_for: "Bestelling voor",
    amount_to_pay: "Te betalen bedrag",
    personal_information: "Persoonlijke informatie",
    please_update: "Update alsjeblieft",
    informations: "Informatie",
    stop_parking: "Stop parkeermeter",
    edit_point_of_interest: "Bewerk de nuttige plaatsen",
    select_payment_method: "Selecteer betaalmethode",
    poi_automatic_trip_classification_explanation:
      "Verklaring automatische ritmodus",
    fuel: "Brandstof",
    default_trip_type_business: "Standaard ritmodus op zakelijk",
    price_per_liter: "Prijs per liter",
    premiumgasoline: "Premium Benzine",
    drivers: "Berijders",
    gasoline: "Benzine",
    authorize_application_description: "Machtiging applicatie",
    admin_info: "Admin info",
    limited_information: "Beperkte informatie",
    first_monthly_data_at: "Eerste maandelijkse data op",
    is_geofence: "Geofence",
    exit_geofence_area: "Geofence gebied",
    vat_number: "BTW",
    enter_address: "Voer adres in",
    location: "Locatie",
    enter_company_email: "Voer bedrijf e-mail",
    stop_location: "Stop locatie",
    points_of_interest: "Nuttige plaatsen",
    select_dongle_imei: "Selecteer een dongel",
    vehicle_name: "Naam voertuig",
    license_plate_type: "Type kenteken",
    private_yellow: "Geel kenteken",
    assign_me_as_driver: "Ik (%{email}) ben ook de berijder",
    create_vehicle: "Voeg voertuig toe",
    general: "Algemeen",
    transaction_at: "Transactie op",
    faq_1: "Hoe zit het met mijn privacy?",
    credit_card: "Creditcard",
    faq_6_description:
      "Ja, de dongel werkt in heel Europa zonder extra kosten.",
    faq_8: "Kan ik meerdere dongels aanschaffen en zien op 1 account?",
    end_time: "Eindtijd",
    update_trip_addreses_from_poi: "Update adres vanuit NP",
    user_odometer: "KM gebruiker",
    motoroil: "Motorolie",
    review_permissions: "Review toestemmingen",
    authorize_application: "Machtig applicatie",
    create_company: "Maak bedrijf aan",
    ideal: "iDeal",
    creditcard: "Creditcard",
    cost: "Kosten",
    faq_1_description:
      'In April 2016 heeft ULU B.V. het keurmerkcertificaat ritregistratiesystemen behaald, waar de Gedragscode Privacy RRS onderdeel van is. In deze gedragscode staan de belangrijkste bepalingen met betrekking tot toepasselijke wet- en regelgeving op het gebied van privacy. Zo ben je ervan verzekerd dat ook de privacy binnen de rittenregistratie voldoet aan de gestelde normen. En voor de Ondernemingsraad binnen de organisatie een extra zekerheid ter instemming voor de introductie van een rittenregistratiesysteem.\r\n<br/>\r\n<br/>\r\nDeze gedragscode is van toepassing op natuurlijke en rechtspersonen die gebruik maken van een door de “Stichting Keurmerk RitRegistratieSystemen” gecertificeerd digitaal rittenregistratiesyteem. Deze gedragscode richt zich zowel tot natuurlijke en/of rechtspersonen die, hetzij als werkgever of zelfstandige, hetzij als werknemer, gebruik maken van een digitaal ritregistratiesysteem.\r\n<br/>\r\n<br/>\r\n Deze Gedragscode bestaat uit de volgende onderwerpen:\r\n<ul>\r\n<li>Rolbeschrijvingen</li>\r\n<li>Principes gegevensverwerking</li>\r\n<li>Inzage en correctie</li>\r\n<li>Informatieplicht</li>\r\n<li>Leverancier</li>\r\n<li>Beveiliging</li>\r\n<li>Voldoen aan wettelijke verplichtingen</li>\r\n<li>Beroepscommissie</li>\r\n<li>Overige onderwerpen</li>\r\n</ul>\r\n<br/>\r\n<br/>\r\nKlik <a href="https://www.keurmerkritregistratiesystemen.nl/privacy/gedragscode">hier</a> voor meer informatie over de Privacy Gedragscode',
    faq_2: "Wat moet ik doen bij problemen met de dongel?",
    device_invoice: "Hardware factuur",
    vehicle_owner: "Eigenaar voertuig",
    travelcard_details: "Travelcard details",
    is_geofence_notify_in: "Schakel Geofence notificatie in",
    enter_geofence_area: "Voeg Geofence gebied toe",
    make_own: "Koppel los",
    no_current_vehicle: "Geen huidig voertuig",
    current_vehicle: "Huidig voertuig",
    add_more_groups: "Voeg meer groepen toe",
    add_a_user: "Voeg een gebruiker toe",
    cheapest_parking_origin_search_text: "Goedkoopste zone",
    stop_meter: "Stop meter",
    author: "Auteur",
    parking_has_no_lat_and_lon: "Parkeerlocatie heeft geen GPS - coördinaten",
    travelcard_has_no_lat_and_lon: "Travelcard heeft geen GPS - coördinaten",
    faq_3:
      "Wat gebeurt er met de gegevens die jullie verzamelen over mijn auto?",
    faq_4: "Hoe weet ik of ik mobiele dekking heb?",
    faq_4_description:
      "Als de motor loopt, kan je dat controleren door te kijken naar het statuslampje. Knippert het lampje rood, dan heb je geen mobiele dekking. Knippert het lampje groen, dan ben je verbonden.",
    faq_5: "Hoe moet ik de dongel instellen en installeren?",
    vehicles_in_segment: "Voertuigen in segment",
    faq_6: "Werkt de dongel in heel Europa?",
    faq_7: "Wat gebeurt er met mijn gegevens?",
    faq_7_description:
      "Persoonlijke gegevens en de ontvangen data van gebruikers worden zorgvuldig behandeld; zie hiervoor de algemene voorwaarden.<br/><br/>ULU B.V. houdt zich aan de Wet Bescherming Persoonsgegevens die de verantwoordelijke is voor de gegevensverwerking. In overeenstemming met genoemde wet is de verwerking aangemeld bij de toezichthouder, het College Bescherming Persoonsgegevens.",
    expires_at: "Verloopt op",
    travelcard_event_at: "Tankbeurt (Travelcard) op",
    parking_start: "Start parkeren",
    part_of: "Deel van",
    geofence: "Geofence",
    make_own_company: "Koppel bedrijf los van jouw maintainer",
    confirm: "Bevestig",
    remove_group: "Verwijder groep",
    add_user_to_group: "Voeg gebruiker toe aan groep",
    single_device_imei: "Enkel device IMEI",
    permitted_for_all_users: "Toegankelijk voor alle gebruikers",
    lost_connection_90: "Verbinding verbroken",
    faq_20_description:
      "Plaats de dongel in de nieuwe auto en stel het op de gebruikelijke manier in. Je ziet de nieuwe auto dan verschijnen in de app en op de webapplicatie.",
    faq_9: "Heb ik een smartphone nodig?",
    faq_9_description: "Nee, je kan ook inloggen via internet (app.ulu.io).",
    faq_10: "Wat gebeurt er als er geen verbinding is?",
    faq_10_description:
      "Als de GPS-verbinding niet beschikbaar is, zal de dongel de data opslaan totdat de verbinding hersteld is. In dat geval zit er mogelijk vertraging in de getoonde data op je ULU account.",
    faq_11:
      "Ik heb de dongel geïnstalleerd en hij toont mijn huidige locatie niet. Hoe kan dat?",
    faq_11_description:
      "De dongel bepaalt de locatie van je auto door middel van GPS welke pas geactiveerd wordt na de eerste rit. De nauwkeurigheid van de locatie hangt af van de nauwkeurigheid van het GPS-systeem. Dit houdt in dat het soms enkele minuten duurt voor een locatie beschikbaar is. Bovendien werkt het systeem vaak niet in garages of andere constructies. Het is ook mogelijk dat er een zwakke GPS-verbinding is op de plaats in je auto waar je de dongel geïnstalleerd hebt. In dat geval kan een verlengkabel noodzakelijk zijn, zodat je de dongel kunt verplaatsen om een betere GPS-ontvangst te krijgen.",
    faq_12: "Wat moet ik doen als ik mijn wachtwoord vergeet?",
    faq_12_description:
      'In het inlogscherm van zowel de website als de app kun je klikken op de knop "Wachtwoord vergeten?". Als je e-mailadres geregistreerd is, wordt er zo een e-mail toegestuurd waarmee je je wachtwoord kunt wijzigen.',
    faq_13:
      "Ik kan de dongel niet goed aansluiten of de dongel zit in de weg. Wat nu?",
    faq_13_description:
      "Het is mogelijk de dongel op een andere plek te installeren met behulp van de verlengkabel en het klittenband. Dit kan een oplossing zijn wanneer de dongel de chauffeur of de passagier in de weg zit of omdat het er gewoon niet mooi uitziet. In het geval van problemen met het bepalen van je positie, kan met de verlengkabel kan je de dongel ook ergens anders plaatsen om zo een betere GPS-ontvangst te krijgen.",
    faq_14:
      "Ik heb de dongel aangesloten op de OBD-poort, maar ik zie mijn auto niet als ik inlog op de ULU app of website. Hoe kan dat?",
    point_of_interest: "Nuttige Plaats",
    faq_15: "Hoe zeg ik mijn abonnement op?",
    faq_15_description:
      "Ga naar www.driveulu.com en vul het retourformulier in. Je ontvang meteen de gegevens om de dongel kosteloos retour te sturen. De dongel moet binnen 15 dagen geretourneerd worden om eventuele extra kosten te voorkomen.",
    faq_16:
      "Ik heb een auto met automatisch start/stop-technologie, beïnvloedt dit mijn ritten?",
    faq_16_description:
      "Ritten starten als de auto wordt gestart en stoppen wanneer de motor wordt uitgezet. Als de motor binnen 5 minuten wordt herstart dan worden de ritten samengevoegd.",
    faq_17: "Hoe kan ik een overzicht van mijn ritten printen?",
    faq_17_description:
      "Je kunt ze exporteren naar Excel door naar rapportages te gaan in de webapplicatie.",
    faq_18: "Waarom staat mijn rit niet bij de Ritten?",
    started_at: "Gestart op",
    faq_19: "Kan ik de dongel in meerdere auto’s gebruiken?",
    faq_19_description:
      "Ja, een auto kan door meerdere accounts worden gevolgd en beheerd. Voeg hiervoor het serienummer van de desbetreffende dongel toe in je ULU account.",
    faq_20: "Hoe moet het als ik een andere auto koop?",
    order_not_completed: "Bestelling niet gelukt!",
    faq_21:
      "Moet ik de dongel loskoppelen voordat ik de auto start met startkabels of naar de garage breng voor onderhoud?",
    faq_21_description:
      "We raden je aan om de dongel los te koppelen wanneer je startkabels gaat gebruiken om de auto te starten of wanneer je de auto wegbrengt voor een onderhoudsbeurt.",
    faq_22:
      "Waarom is het zo moeilijk om de dongel los te koppelen van de OBD-poort?",
    faq_22_description:
      "De dongel is zo ontworpen dat het stevig vast blijft zitten in alle auto’s, zonder los te raken of uit de aansluiting te vallen. Wanneer je over een hobbelige weg rijdt, zou de dongel door de trilling los kunnen raken als de aansluiting niet precies zou passen.",
    faq_23: "Wat is de juiste manier om de dongel te verwijderen?",
    add_manual_trip: "Voeg handmatig een rit toe",
    vehicle_successfully_added:
      "Voertuig is succesvol toegevoegd aan jouw wagenpark.",
    additional_user_info_not_required: "Extra informatie (niet verplicht)",
    actions: "Acties",
    activation_code: "Activatie code",
    active: "Actief",
    inactive: "Inactief",
    add_payment_link_to_email: "Voeg betaal link to aan email",
    selected_value: "Geselecteerde waarde",
    delete_company: "Verwijder bedrijf",
    delete_push_notification: "Verwijder pushbericht",
    push_notification_sucessfully_created: "Pushbericht succesvol gemaakt",
    actived_devices: "Geactiveerde dongels",
    active_devices: "Actieve dongels",
    add_dongles: "Voeg een dongel toe",
    add_new_vehicle: "Voeg een nieuw voertuig toe",
    add_previous_trip_stop_as_new_start:
      "Wil je de stop-locatie van de vorige trip als start-locatie van de huidige trip?",
    alert_html: "Succesvol opgeslagen",
    all_company_users: "Alle gebruikers van het bedrijf",
    apply_tax: "Pas belasting toe",
    assign_fleet_admin_as_driver:
      "Wijs wagenparkbeheerder (%{email} toe als berijder",
    billing_firstname: "Voornaam",
    billing_lastname: "Achternaam",
    billing_phone: "Telefoonnummer",
    groups: "Groepen",
    deviant_route_reason: "Reden afwijkende route",
    deviant_route_note: "Notitie afwijkende route",
    trip_score: "Rit score",
    group: "Groep",
    vehicle_not_selected: "Voertuig niet geselecteerd",
    days: "Dagen",
    all_groups: "Alle groepen",
    view_only_map: "Bekijk alleen de kaart",
    view_only_live_view: "Bekijk alleen liveweergave",
    limit_permissions_to_map_view: "Beperk permissies om live te bekijken",
    fleet_live_only: "Alleen de live locatie volgen",
    add_vehicle: "Voertuig toevoegen",
    add_poi: "Maak een nieuwe nuttige plaats aan",
    add_service: "Service toevoegen",
    additional_company_info: "Aanvullende bedrijfsinformatie",
    add_vehicle_and_driver: "Voertuig en bestuurder toevoegen",
    after: "na",
    administrator_also_driver: "Beheerder ook bestuurder",
    add_fuel_event: "Voeg brandstof gebeurtenis toe",
    add_permission: "Voeg toestemming toe",
    unlink_users: "Gebruikers ontkoppelen",
    unlink_users_confirmation:
      "Weet je zeker dat je de gebruikers wilt ontkoppelen van dit bedrijf?",
    add_another_vehicle: "Voeg een ander voertuig toe",
    add_manual_odometer: "Wijzig zelf de kilometerstand",
    all_dongles_connected_buy_new:
      "Alle beschikbare dongels zijn in gebruik. Je kan nieuwe dongels bestellen of dongels uit andere voertuigen halen.",
    apply_to_all: "Pas bij alle toe",
    billing_address: "Factuuradres",
    billing_city: "Plaatsnaam",
    billing_zip_code: "Postcode",
    back: "Terug",
    deviant: "Afwijkend",
    without_group: "Zonder groep",
    company_group: "Bedrijfsgroep",
    company_user_groups: "Gebruikersgroep van het bedrijf",
    company_group_ids: "Bedrijfsgroep ID 's",
    add_group: "Groep toevoegen",
    avg_duration_per_visit: "Gem. tijdsduur per bezoek",
    vehicle_search: "Voertuig zoeken",
    permissions_details: "Wijzig de gebruikersrechten",
    add_company: "Bedrijf toevoegen",
    view_driver_id: "Bekijk berijder ID",
    create_company_users: "Creëer gebruikers bij een bedrijf",
    destroy_point_of_interest: "Verwijder POI 's",
    permitted_for: "Toegankelijk voor",
    news: "Nieuws",
    faq_5_description:
      "De dongel moet worden ingeplugd in de OBD-poort. Deze afkorting staat voor On Board Diagnostics. Dit is de plek waar de boordcomputer van de auto wordt uitgelezen. Wanneer de dongel is geplaatst, wordt automatisch de informatie die wij nodig hebben met je ULU account gedeeld.\r\n<br/> <br/>\r\nDe plek van de OBD-poort kan per auto verschillen, maar is meestal te vinden in de buurt van het stuurkolom. De meest voorkomende plekken zijn:\r\n<br/> <br/> <ul>\r\n<li>1.\tlinks van de pedalen\r\n<li>2.\tonder het stuur\r\n<li>3.\trechts van de pedalen\r\n",
    assign_previous_trip_stop_data_as_start:
      "Wijs voorgaande stop data van de trip toe als start data",
    assign_next_trip_start_data_as_stop:
      "Wijs volgende start data van de trip toe als stop data",
    automatic_incasso: "Automatische incasso",
    a_trip_already_exists_at_that_time:
      "Er bestaat al een trip op dat tijdstip",
    avg_speed: "Gem. snelheid",
    billing_address_and_house_number: "Factuuradres en huisnummer",
    company_has_no_dongles:
      "Jullie hebben op dit moment geen dongels meer beschikbaar om een nieuwe auto toe te voegen. Je kan een dongel loskoppelen van een andere auto of natuurlijk een nieuwe dongels bestellen bij ons! Neem contact met ons op via %{link} of %{phone}. Dan regelen wij het zo snel mogelijk!",
    billing_country: "Land",
    billing_email: "Emailadres",
    billing_postal_code: "Postcode",
    billing_street_and_house_number: "Straatnaam en huisnummer",
    blank: "Leeg",
    car: "Auto",
    company_address: "Zakelijk adres",
    company_cant_be_driver_for_keurmerk:
      "Als het Keurmerk is ingeschakeld, kan een bedrijf niet toegewezen worden als bestuurder",
    administrator_information_content:
      "De beheerder ontvangt een e-mail met een uitnodiging om in te loggen. ",
    company_name: "Bedrijfsnaam",
    company_phone: "Telefoonnummer",
    confirmation: "Bevestiging",
    confirm_payment: "Bevestig betaling",
    connected_dongles: "Connected dongels",
    correction: "Correctie",
    correction_date: "Datum van correctie",
    correction_trip: "Gecorrigeerde trip",
    correction_trip_details: "Details van gecorrigeerde trip",
    created: "Gecreëerde",
    created_on: "Gecreëerd op",
    create_new_company: "Voeg een nieuw bedrijf toe",
    create_new_user: "Voeg nieuwe gebruiker toe",
    create_user: "Voeg gebruiker toe",
    current_status: "Huidige status",
    current_user_role: "Huidige gebruikersrol",
    datetime_oil_change: "Datum olie verversen",
    datetime_registration: "Datum registratie",
    datetime_service: "Datum onderhoud",
    datetime_tire_rotation: "Datum bandenwissel",
    deleted_at: "Verwijderd op",
    description: "Beschrijving",
    notification_settings:
      "Stel hier in welke melding je op welke manier wilt ontvangen!",
    deviant_distance: "Afwijkende afstand",
    company_user_group_ids: "Gebruikersgroep ID van het bedrijf",
    devices: "Dongels",
    devices_no: "Dongel nummers",
    device_software_version: "Dongel software versie",
    company_email: "E-mail",
    notify_no_gps: "Geen GPS-verbinding",
    enable_custom: "Instellingen per auto",
    set_global_or_custom_notifications:
      "Stel normale of aangepaste meldingen in",
    disconnect_dongle_confirmation:
      "Het voertuig blijft zichtbaar in het ULU dashboard. De dongels is beschikbaar voor een ander voertuig. Weet je het zeker om de dongel los te koppelen?",
    postal_code: "Postcode",
    dongle_information: "Dongel informatie",
    has_deviant_route: "Heeft afwijkende route",
    managed_groups: "Beheerde groepen",
    is_admin: "Is Admin",
    avg_duration: "Gem. tijdsduur",
    delete_companies: "Verwijder bedrijven",
    create_services: "Creëer services",
    right_dashboard: "Rechten van het dashboard",
    limited_api_only: "Alleen beperkte API",
    select_specific: "Selecteer gebruikers",
    helpcenter: "Helpcenter",
    "en.ulu_updates.description": "Omschrijving",
    video_url: "Video URL",
    devices_status: "Dongel status",
    disconnected_dongles: "Beschikbare dongels",
    disconnect_vehicle: "Koppel voertuig los",
    password_confirmation: "Wachtwoord bevestigen",
    faq: "FAQ",
    faq_category: "FAQ categorie",
    faq_category_id: "FAQ categorie",
    can_assign_driver_to_disconnected_vehicle:
      "Je kan geen berijder toewijzen aan een losgekoppelde auto",
    faq_14_description:
      'Volg de installatieprocedure en let erop dat je elke stap goed afrondt. Neem eventueel contact op met de helpdesk: <A HREF="mailto:info@driveulu.com">info@driveulu.com</A>',
    terms_and_conditions_accept:
      "Om onze portal te gebruiken moet je akkoord gaan met onze %{link}",
    dongle_imei: "Dongel IMEI",
    private_gray: "Grijs kenteken (bestelwagen)",
    enabled: "Ingeschakeld",
    employee: "Werknemer",
    driver: "Berijder",
    too_short: "Te kort",
    edit_password: "Wijzig wachtwoord",
    save_password: "Wachtwoord opslaan",
    password_change_content: "Maak een wachtwoord aan voor jouw ULU dashboard",
    password_change_success: "Wachtwoord is succesvol opgeslagen",
    edit_user: "Bewerk gebruiker",
    dutch: "Nederlands",
    waiting_for_connection: "Wacht op connectie",
    settings: "Instellingen",
    select_date_range: "Selecteer een periode",
    keurmerk_xml: "Keurmerk XML",
    registration_more_devices_description:
      "Heb je meer dan één dongel gekocht? Super! Kies nu één IMEI nummer, de rest kan je later registreren via jouw ULU dashboard!",
    salesforce_id: "Salesforce id",
    frequently_asked_questions: "Meest gestelde vragen",
    view_vehicles_location: "Bekijk de locaties van de voertuigen",
    vehicle_owner_name: "Naam van de eigenaar van het voertuig",
    vehicle_driver_name: "Naam van de berijder",
    vat: "BTW",
    fleet_admin: "Fleet admin",
    edit_notification_settings: "Wijzig notificatie instellingen",
    faq_18_description:
      'Druk op de Refresh-knop van de app of website en wacht tot 2 minuten tot alle gegevens bijgewerkt zijn. Staat je rit er nog steeds niet bij, dan kan het zijn dat het starten en uitzetten van de motor niet gesignaleerd is. Maak nog een rit en kijk of die wel verschijnt. Nog steeds niets? Neem dan contact met de helpdesk via tel: +31 (0)40 240 5555 of <A HREF="mailto:info@driveulu.com">info@driveulu.com</A>',
    faq_search_input_placeholder: "Wat is jouw vraag?",
    invalid: "Ongeldig",
    there_are_no_trips_today:
      "Er zijn vandaag (nog) geen ritten geregistreerd.",
    wrong_length: "Verkeerde lengte",
    dongels: "",
    add_new_dongle: "Voeg een dongel toe",
    add_dongle: "Voeg dongel toe",
    dongles: "Dongels",
    recent_first: "Laatste rit",
    hotspot_successfully_created: "Hoppa! Opgeslagen!",
    gedragscode_rit_registratie_systemen: "Gedragscode RitRegistratieSystemen",
    instructions: "Gebruikershandleiding",
    home_address: "Thuisadres",
    work_address: "Werkadres",
    private_visit_address: "Bezoekadres – Privé",
    business_visit_address: "Bezoekadres – Zakelijk",
    stop_poi_address: "Tussenstop (bijv. tankstation, rustplaats) ",
    other: "Anders, namelijk…",
    keurmerk_ritregistratiesystemen: "Keurmerk Ritregistratiesystemen",
    step_one:
      "Stap 1: Voer je persoonlijke / voertuig gegevens in en registreer het certificaat.",
    instructions_3: "Let’s go, ULU!",
    instructions_3_description:
      "Registratie gelukt? Gefeliciteerd, je bent nu officieel wagenparkbeheerder! Dat staat mooi op jouw CV! Nu moet je nog jouw auto toevoegen en het certificaat registreren. ",
    step_five:
      "Stap 5: Ga snel weer wat anders doen, ritregistratie was nog nooit zo gemakkelijk!",
    step_four: "Stap 4: Exporteer en rapporteer.",
    step_three: "Stap 3: Update (maandelijks) je rittenoverzicht.",
    step_two: "Stap 2: Configureer jouw Drive ULU dashboard!",
    instructions_5: "Registreer het certificaat",
    custom: "klik hier om de instellingen per auto aan te passen",
    instructions_2_description:
      'ULU vindt jouw privacy ontzettend belangrijk en heeft dan ook een aantal stappen genomen om deze te borgen. Het registreren van ritten raakt vrijwel altijd de Wet bescherming Persoonsgegevens. Daarom is het van belang om een ritregistratiesysteem te kiezen met het Keurmerk RitRegistratieSystemen. Deze zijn door de stichting grondig gekeurd op het gebruik van data / gegevens en het veiligstellen / waarborgen van jouw privacy. Een systeem zoals ULU dus! \r\n</br></br>\r\nULU verzameld miljoenen (misschien wel miljarden!) data van iedereen die met ULU rijdt. Wij gaan zorgvuldig met de gegevens om en zorgen voor een ijzersterke / niet te kraken beveiliging van deze data, en voldoen 100% aan alle betreffende wet- en regelgeving. Geen zorgen wij respecteren altijd jouw privacy. Daarom streven wij volledig de Privacy Gedragscode Keurmerk RitRegistratieSystemen na. Op die manier voldoet zowel jouw werkgever als jij zelf aan de “ Privacy Gedragscode”. \r\n</br></br>\r\n“De wat en welke code?” Geen zorgen, ULU legt het je uit. De Privacy Gedragscode zorgt er simpelweg voor dat jouw privacy gewaarborgd wordt. Zo zorgen wij ervoor als jij de ritmodus op privé zet, niemand anders ziet waar jij op dat moment bent, naar toe rijdt of bent geweest. Je mag namelijk 500 kilometer privé rijden, zonder dat je bijtelling hoeft te betalen! Dat is op en neer van Amsterdam naar Antwerpen of een enkele reis naar Parijs! Ook kun je een aantal keer je kinderen naar school brengen of ophalen van sport. Al jouw privé kilometers (<500 kilometer per jaar) gaat natuurlijk niemand wat aan! \r\n</br></br>\r\nDe Stichting Keurmerk RitRegistratieSystemen heeft een Privacy Gedragscode opgesteld en ingediend bij College Bescherming Persoonsgegevens met als onderdeel een bijbehorende beroepscommissie. Deze beroepscommissie behandelt en onderzoekt alle klachten. Jij als ULU ‘er kunt hier altijd terecht.\r\n</br></br>\r\nRespecteer deze code, en je houdt je gelijk aan de wet- en regelgeving rondom Wet bescherming Persoonsgegevens. <a href="https://www.keurmerkritregistratiesystemen.nl/privacy/gedragscode">Lees meer over de Privacy Gedragscode</a>  ',
    instructions_4: "Voertuig toevoegen / persoonlijke gegevens aanvullen",
    instructions_5_description:
      'Nadat je ULU geactiveerd hebt, kun je gemakkelijk het certificaat downloaden bij ‘voertuig details’! Vergeet dit keurmerkcertificaat, voorzien van jouw unieke nummer, niet te activeren op de website van de Stichting Keurmerk RitRegistratieSystemen. Dat doe je hier: <a href="https://www.keurmerkritregistratiesystemen.nl/certificaat" target="_blank">www.keurmerkritregistratiesystemen.nl/certificaat</a>. </br></br> Let op; zonder activatie is het keurmerk nog niet geldig! Gelukt? Vanaf nu worden jouw ritten bijgehouden!\r\n\r\n',
    transaction_fee: "Transactiekosten",
    delete_cms_segment: "Verwijder segment",
    view_private_trips_location: "Bekijk de locatie van privé ritten",
    view_vehicles_private_location: "Bekijk de privé locatie van het voertuig",
    vehicle_driver: "Berijder van het voertuig",
    fleet_group_admin: "Groep admin",
    "nl.ulu_updates.description": "Omschrijving",
    file_format_error: "Bestandsindeling fout",
    import_btn_disabled: "Invoer btn",
    is_electric: "Is elektrisch",
    view_private_trips: "Bekijk privé ritten",
    view_trips_location: "Bekijk de locatie van de ritten",
    notification: "Melding per auto instellen",
    "error_CONNECTION LOST_description": "Verbinding verbroken",
    start_stop_location_empty: "De trip mist een start en/of stop location",
    instructions_10_description:
      "Klik op ‘wijzig rit’ (onder de kaart) om de rit te bewerken.\r\n</br></br>\r\nIs een begin- of eindlocatie niet beschikbaar (‘unnamed road’), klik dan op het icoontje. De Drive ULU app vult dan automatisch de ritgegevens aan met de locatiegegevens van de vorige rit (indien aanwezig).\r\n</br></br>\r\nHeb je een afwijkende route genomen of heb je wat gecombineerd in de rit (bijv. woon werk met privé omweg)? Klik dan op ‘afwijkende route’ en vul de rit aan.\r\n</br></br>\r\nLet op: Alle ritten moeten een start- en stopadres hebben voor de belastingdienst. Vul je ritten handmatig aan met de juiste informatie.",
    instructions_11: "Update je kilometerstand",
    instructions_13_description:
      "Selecteer een voertuig op het rapport scherm uit het voertuigenoverzicht bovenaan de pagina. Na selectie van het voertuig verschijnt er een groene “keurmerk xml” knop.\r\n</br></br>\r\nOp het volgende scherm verschijnt er een rood gebied met een beschrijving van de gegevens die nog missen voordat het rapport kan worden uitgedraaid. Wanneer alles volledig en juist is ingevuld, verschijnt de mogelijkheid om het jaartal te selecteren en wordt het rapport beschikbaar (rapporten kunnen enkel worden uitgedraaid voor een volledig jaar). Na een paar minuten (afhankelijk van het aantal ritten) is het rapport te downloaden.\r\n</br></br>\r\nDe keurmerkrapportage vanuit ULU bevat de XAR. De XAR is voorzien met een speciaal keurmerknummer en wordt herkent door de Belastingdienst als een rapportage afkomstig uit een keurmerksysteem. Lever jouw rapportage dan ook altijd in bij de Belastingdienst vanuit de keurmerkrapportage van ULU met de XAR.\r\n</br></br>\r\nAlle gegevens worden 18 maanden bewaard op het online ULU account. Dit is een verplichte bewaartermijn volgens het Keurmerk RitRegistratieSystemen.",
    instructions_8: "Privacy",
    instructions_10: "Ritten bewerken",
    instructions_11_description:
      "Het regelmatig updaten van de kilometerstand is heel belangrijk. Ga naar ‘voertuig details’ om je kilometerstand te corrigeren (klik op ‘update’). Je komt in een overzicht genaamd ‘kilometerteller correctie’. Geef de nieuwe actuele kilometerstand op, je krijgt de keuze tussen twee opties:\r\n</br></br>\r\n<ul>\r\n<li>Voeg automatische ritcorrectie toe</br>\r\n<p>\r\nEen automatische ritcorrectie is een aangemaakte rit zonder locatiegegevens. Deze wordt gebruikt om het verschil te corrigeren van de gemeten afstand door de auto en de afstand opgenomen door de dongel. De automatische rit wordt berekend op basis van je eerdere ritten en de verdeling van deze ritten (zakelijk, woon-werk en privé). De gecorrigeerde rit neemt precies het gewogen gemiddelde van deze verschillende ritten en corrigeert hiermee jouw kilometerstand.\r\n</p>\r\n</li>\r\n<li>Voeg automatische ritcorrectie toe</br>\r\n<p>\r\nEen automatische ritcorrectie is een aangemaakte rit zonder locatiegegevens. Deze wordt gebruikt om het verschil te corrigeren van de gemeten afstand door de auto en de afstand opgenomen door de dongel. De automatische rit wordt berekend op basis van je eerdere ritten en de verdeling van deze ritten (zakelijk, woon-werk en privé). De gecorrigeerde rit neemt precies het gewogen gemiddelde van deze verschillende ritten en corrigeert hiermee jouw kilometerstand.\r\n</p>\r\n</li>\r\n<li>Afwijkende route</br>\r\n<p>\r\nWeg afgesloten, slechte weersomstandigheden,… soms nemen we een andere route dan gebruikelijk. Voeg de extra afstand en een korte notitie toe als toelichting voor het nemen van deze route. \r\n</p>\r\n</li>\r\n</ul>",
    instructions_12: "Rapporten en Export",
    instructions_12_description:
      "Rapporten geven gegroepeerde gegevens weer over een bepaalde periode. Door andere filters in te stellen kun je een rapportage creëren geheel naar eigen voorkeuren. Alle rapporten kunnen geëxporteerd worden naar excel of csv formaat.\r\n</br></br>\r\nMocht je toch bepaalde informatie missen of heb je een specifiek rapport nodig, neem dan gerust contact met ons op via info@ulu.io  ",
    instructions_13: "Keurmerk xml export (XAR)",
    instructions_6: "Nuttige plaatsen",
    instructions_7: "Notificaties",
    instructions_7_description:
      "De Drive ULU app ondersteunt je in belangrijke acties of bij belangrijke onderwerpen. Geeft je auto een storing of is je brandstof tank bijna leeg? Maar ook; heeft de dongel connectie of dient een rit geüpdatet te worden. </br></br> Ongelezen en gelezen notificaties worden weergegeven als je op de wereldbol klikt. Sommige notificaties vereisen van jou een handeling. Klik op de notificatie en je komt automatisch in het gedeelte waar je de gegevens kunt aanvullen.",
    instructions_8_description:
      "In de Drive ULU app kan je per rit aangeven of het een rit betreft die privé, zakelijk of woon-werk verkeer is. </br></br> Het aanpassen van het rittype beïnvloedt de zichtbaarheid van de ritten. Als het voertuig onderdeel is van een wagenpark zijn privé ritten niet zichtbaar voor de wagenpark-beheerder. Bij het rittenoverzicht kan je per rit achteraf het ritmodus nog wijzigen.",
    instructions_9: "Rollen",
    instructions_9_description:
      'Het ULU ritregistratie systeem heeft verschillende functionaliteiten. Zo kun je gemakkelijk meerdere auto’s toevoegen en beheren. Dit noemen wij bij ULU de ‘ wagenparkbeheerders inlog’ (mooi scrabble woord). Iedereen krijgt die inlog als je je aanmeldt bij ULU. Handig! Als je meerdere auto’s hebt rijden (bijv. als bedrijf), heb je alle auto’s overzichtelijk in één dashboard. Super makkelijk! </br></br> Er is alleen wel iets wat je moet weten. Als je een auto hebt met het ULU systeem voor het keurmerk, dan zijn all privé ritten niet zichtbaar voor een wagenparkbeheerder. Dit vanwege de ‘Privacy Gedragscode’ waar ULU zich uiteraard aan houdt! </br></br> Ben je wagenparkbeheerder en heb je ook een eigen voertuig en wil je je eigen privé ritten bekijken, bewerken of wil je jouw keurmerk XML export genereren, wissel dan van rol (van wagenparkbeheerder naar berijder). </br></br> Klik linksonder op dit icoontje: <img src="https://ulu.s3.amazonaws.com/drive_ulu_images/images/000/000/005/original/users_web.png" width="35" height="35"> . Je ziet vervolgens of je ingelogd bent als ‘fleet admin’ of als berijder. Klik op de pijltjes om van rol te wisselen. </br></br> Normale berijders kunnen niet van rol veranderen enkel de wagenparkbeheerder. <img src="https://ulu.s3.amazonaws.com/drive_ulu_images/images/000/000/006/original/users_menu_web.png" width="300">',
    notification_default_email_message: "Je hebt een nieuwe melding van ULU!",
    notifications_cant_disable_keurmerk:
      "Sommige meldingen kunnen niet uitgeschakeld worden.",
    set_vehicle_notifications: "Stel voertuig meldingen in",
    user_help_introduction_description:
      'De Belastingdienst maakt het niet leuker, wel makkelijker. De belastingdienst heeft, samen met het bestuur van de Stichting Keurmerk Ritregistratiesysteem en PwC, een aantal normen vastgesteld voor een perfecte ritregistratie. Wanneer een ritregistratiesysteem voldoet aan deze normen, kom je in aanmerking voor het keurmerk en daarmee een verlicht controleregime van het Horizontaal Toezicht. Wat houdt dat nu weer in, hoor ik je denken! Dat zit zo; de Belastingdienst controleert de ritregistratie op logica (Is de rit wel gereden? Klopt de rit met tankbeurten en / of boetes? Of is de rittenregistratie achteraf ingevuld met geschatte kilometerstanden en locaties?). Daarnaast kijkt de Belastingdienst of de ritten al dan niet zakelijk zijn (bijvoorbeeld bij een rit op zondag) en of jij dit kan verklaren met onderliggend bewijs (je zakelijke agenda). </br></br> Bij een Ritregistratiesysteem met het keurmerk vervalt deze eerste controle. Enkel nog bij specifieke vragen, moet je een verklaring geven. Ook zijn er minder steekproeven bij desbetreffende (keurmerk) systemen. </br></br> Het ritregistratiesysteem van ULU is gecertificeerd met het Keurmerk Ritregistratiesystemen. Hierdoor ben je gegarandeerd van kwalitatief goede rittenregistratie, die voldoet aan de eisen van de Belastingdienst. Ook ben je verzekerd dat jouw privacy geborgd is en dat ULU altijd voldoet aan de laatste wetgeving, nu en in de toekomst. </br></br> Maar let wel op! Je moet nog een aantal (verplichte) stappen doorlopen om het certificaat aan te melden bij de Stichting Keurmerk RitRegistratieSystemen. Doorloop de 5 genoemde stappen dan ook zorgvuldig, zodat je optimaal van ULU gebruik maakt. </br></br> Nadat je ULU geactiveerd hebt, kun je gemakkelijk het certificaat downloaden! Klik op het auto icoontje links in het scherm, ga naar voertuig details scroll naar beneden en klik op het pdf document. Vergeet niet dit keurmerkcertificaat, voorzien van jouw unieke nummer, te activeren op de website van de Stichting Keurmerk RitRegistratieSystemen (<a href="https://www.keurmerkritregistratiesystemen.nl/certificaat" target="_blank">klik hier</a>)',
    no_gps: "Geen GPS-verbinding",
    empty_location: "Start/stop locatie is leeg",
    notify_lost_connection: "Verbinding verbroken",
    imported: "Geïmporteerd",
    do_import: "Import doen",
    nearest_parking_search_text: "Dichtstbijzijnde zone bij jouw bestemming",
    msp: "MSP",
    view_keurmerk_reports: "Bekijk keurmerk rapportages",
    refreshing: "Laden...",
    owner_description_text:
      "Eigenaar kan voertuig ritten, status en locatie zien. Je kunt ritten markeren als privé zodat deze niet zichtbaar zijn voor het bedrijf.\r\n",
    vehicle_identificators: "Voertuig ID",
    dongle_replug: "Dongel opnieuw aangesloten",
    vehicle_services: "Voertuig onderhoud / service",
    permanent_vehicle_error: "Voertuig foutcodes",
    keurmerk_will_be_assigned: "Keurmerk wordt toegewezen",
    keurmerk_will_be_assigned_text: "Keurmerk wordt toegewezen",
    user_successfully_updated:
      "Hoppa! Gelukt! De gebruiker is succesvol geüpdatet.",
    trip_was_successfully_updated:
      "Ja, gelukt! De trip is succesvol geüpdatet!",
    updated_odometer_at: "De kilometerstand is geüpdatet op",
    updated_at: "Geüpdatet op",
    introduction: "Introductie",
    register_certificate: "Registreer jouw keurmerkcertificaat",
    user_help_register_certificate_description:
      'Om echt gebruik te maken van het keurmerkcertificaat, moet je deze registreren op de website van Stichting Keurmerk RitRegistratieSystemen. </br></br> Dit is heel simpel: </br> <ul> <li>1. Download het certificaat vanuit het ULU dashboard bij ‘voertuig details’.</li> <li>2. Ga naar <a href="https://www.keurmerkritregistratiesystemen.nl/certificaat"  target="_blank">de website van Stichting Keurmerk RitRegistratieSystemen</a> en vul jouw unieke certificaatnummer in (beginnend met ULU).</li> <li>3. Vul vervolgens jouw kenteken in en klik op registreren.</li> <li>4. Klaar! </li> </ul>',
    import_btn: "Import btn",
    cheapest_parking_search_text: "Goedkoopste zone bij jouw bestemming",
    additional_message: "Extra bericht",
    nearest: "Dichtstbijzijnde",
    cheapest: "Goedkoopste",
    iframe_page: "iFrame pagina",
    hotspots_permission: "Rechten van POI",
    price: "Prijs",
    "nl.ulu_updates.title": "Titel",
    "en.ulu_updates.title": "Titel",
    faq_2_description:
      'Vermoed je dat de dongel defect is, dan kan je contact opnemen met de helpdesk via tel: +31 (0)40 240 5555 of <A HREF="mailto:info@driveulu.com">info@driveulu.com</A>.',
    services_permission: "Rechten voor services",
    vehicle_ids: "Voertuig ID",
    instructions_4_description:
      "Klik op het auto icoontje en klik vervolgens op het plusje (+). </br></br> Selecteer een dongel en vul vervolgens de gegevens in over de auto. Vergeet vooral het VIN nummer niet, deze is verplicht voor het Keurmerk! </br></br> VIN nummer wat is dat nu weer? Het VIN nummer (Voertuig Identificatie Nummer) wordt ook wel het chassisnummer genoemd en geeft jouw voertuig een unieke identiteit, soort vingerafdruk van jouw auto. Het VIN nummer heeft 17 karakters en eindigt altijd met 6 cijfers. Je vindt het VIN nummer op je kentekenbewijs of in de voorruit van de auto zelf. </br></br> Ben jij de wagenparkbeheerder en berijder? Kies dan voor de optie: ‘ik ben ook de berijder’. Voor de Belastingdienst is het belangrijk dat je jouw BSN nummer invult en fiscale status aangeeft. Ook de andere velden met een (*) zijn verplicht. Vul je persoonlijke gegevens aan als deze nog niet compleet waren. Gelukt? Je krijgt een mail met uitnodiging om toegevoegd te worden aan het wagenpark!",
    instructions_6_description:
      'Zijn er locaties waar je regelmatig naar toe rijdt? Wat dacht je bijvoorbeeld van je woon- en werkadres! Deze locaties (Nuttige plaatsen ofwel Points of interest) kun je gemakkelijk instellen in het dashboard.\r\n</br></br>\r\nKlik op dit icoontje: <img src="https://ulu.s3.amazonaws.com/drive_ulu_images/images/000/000/004/original/poi_web.png" width="35" height="35"> . Door op het plusje te klikken, kan je een nieuwe Point of interest (POI) toevoegen. \r\n</br></br>\r\nOm het makkelijk te maken, hebben wij alvast een aantal vaste POI ’s ingesteld; thuisadres, werkadres, privé adres, zakelijk adres, nuttige plaats (tankstation o.i.d.). Ook heb je de mogelijkheid om zelf een POI te benoemen (kies dan ‘other’).\r\n </br></br>\r\nAls je de POI ’s ingesteld hebt, herkent de app vanzelf als een rit hier begint of eindigt. De rit wordt dan automatisch gekoppeld aan de ingestelde POI ‘s. Makkelijk!\r\n </br></br>\r\nTip: Als een adres niet wordt gevonden, vul dan handmatig de coördinaten in. Deze kan je online via, bijvoorbeeld op: <a href="http://www.latlong.net" target="_blank">www.latlong.net</a>.',
    instructions_1_description:
      'De Belastingdienst maakt het niet leuker, wel makkelijker. De belastingdienst heeft, samen met het bestuur van de Stichting Keurmerk Ritregistratiesysteem en PwC, een aantal normen vastgesteld voor een perfecte ritregistratie. Wanneer een ritregistratiesysteem voldoet aan deze normen, kom je in aanmerking voor het keurmerk en daarmee een verlicht controleregime van het Horizontaal Toezicht. Wat houdt dat nu weer in, hoor ik je denken! Dat zit zo; de Belastingdienst controleert de ritregistratie op logica (Is de rit wel gereden? Klopt de rit met tankbeurten en / of boetes? Of is de rittenregistratie achteraf ingevuld met geschatte kilometerstanden en locaties?). Daarnaast kijkt de Belastingdienst of de ritten al dan niet zakelijk zijn (bijvoorbeeld bij een rit op zondag) en of jij dit kan verklaren met onderliggend bewijs (je zakelijke agenda). \r\n</br></br>\r\nBij een Ritregistratiesysteem met het keurmerk vervalt deze eerste controle. Enkel nog bij specifieke vragen, moet je een verklaring geven. Ook zijn er minder steekproeven bij desbetreffende (keurmerk) systemen. \r\n</br></br>\r\nHet ritregistratiesysteem van ULU is gecertificeerd met het Keurmerk Ritregistratiesystemen. Hierdoor ben je gegarandeerd van kwalitatief goede rittenregistratie, die voldoet aan de eisen van de Belastingdienst. Ook ben je verzekerd dat jouw privacy geborgd is en dat ULU altijd voldoet aan de laatste wetgeving, nu en in de toekomst. \r\n</br></br>\r\nMaar let wel op! Je moet nog een aantal (verplichte) stappen doorlopen om het certificaat aan te melden bij de Stichting Keurmerk RitRegistratieSystemen. Doorloop de 5 genoemde stappen dan ook zorgvuldig, zodat je optimaal van ULU gebruik maakt.\r\n</br></br>\r\nNadat je ULU geactiveerd hebt, kun je gemakkelijk het certificaat downloaden! Klik op het auto icoontje links in het scherm, ga naar voertuig details scroll naar beneden en klik op het pdf document. Vergeet niet dit keurmerkcertificaat, voorzien van jouw unieke nummer, te activeren op de website van de Stichting Keurmerk RitRegistratieSystemen. Dat doe je hier: <a href="https://www.keurmerkritregistratiesystemen.nl/certificaat" target="_blank">www.keurmerkritregistratiesystemen.nl/certificaat</a>.',
    dashboard_icon: "Dashboard icoon",
    company_details: "Bedrijfsgegevens ",
    posted_by: "Gepost door",
    trip_costs: "Kosten per rit",
    company_users_permission: "Rechten voor gebruikers (bedrijf)",
    hotspots: "POI 's",
    maintainer: "Maintainer",
    add_new_push_notification: "Voeg nieuw pushbericht toe",
    Fleetowner: "Fleetowner",
    trips_permission: "Rechten voor ritten",
    devices_permission: "Rechten voor devices",
    number_of_trips: "Aantal ritten",
    odometer_read_at: "Kilometerstand gelezen op",
    odometer_read: "Kilometerstand gelezen",
    first_data: "Eerste connectie",
    read_at: "Eerste connectie",
    dutch_bank_account_needed: "Nederland",
    traffic: "Verkeersinfo",
    odometer_when_completed: "Kilometerstand bij onderhoud",
    is_read_only: "Alleen lezen",
    maintainance_delay:
      "LET OP: Er wordt aan het systeem gewerkt. Er gaan geen gegevens verloren, maar er kan vertraging oplopen. Excuses voor het ongemak.",
    trip_or_parking_is_active_cant_disconnect:
      "Je kan het voertuig niet loskoppelen; er is op dit moment een rit of parkeeractie actief je kan het voertuig niet loskoppelen.",
    companies_permission: "Rechten voor bedrijven",
    import_type: "Import type",
    delete_services: "Verwijder services",
    view_services: "Bekijk services",
    read_notifications: "Lees notificaties",
    edit_company_users: "Bewerk gebruikers van een bedrijf",
    view_fleet_reports: "Bekijk wagenpark rapportages",
    price_per: "Prijs per %{distance_unit}",
    fontello_icon_code: "Fontello icon code",
    vehicle_drivers: "Berijders van de auto",
    view_company_users: "Bekijk gebruikers van het bedrijf",
    user_role: "Gebruikersrol",
    user: "Gebruiker",
    user_id: "Gebruiker",
    vehicles_for_segment: "Voertuigen voor het segment",
    radius: "Radius",
    'vehicle_enters_geofence"': "Auto rijdt geofence binnen",
    reports_history: "Rapportage geschiedenis",
    trip_usage: "Verbruik per rit",
    costs: "Kosten",
    source: "Bron",
    all_sources: "Alle bronnen",
    commute_distance: "Afstand (woon-werk)",
    notifications_email: "Notificaties e-mail",
    not_active: "Niet actief",
    navigation: "Navigatie notificaties (app)",
    braking_below_20: "Slechte remscore",
    acceleration_below_20: "Slechte acceleratiescore",
    driving_between_18_and_06:
      "Auto gebruikt buiten werktijden (tussen 18:00 en 06:00)",
    driving_weekend: "Auto gebruikt in het weekend",
    user_name: "Gebruikersnaam",
    user_email: "Gebruikers email",
    send_to_all_segments: "Stuur naar alle segmentaties",
    send_push_notification: "Verstuur pushbericht",
    add_push_notification: "Voeg pushbericht toe",
    push_notification_message: "Pushbericht",
    min_year: "Min. bouwjaar",
    add_new_segment: "Maak nieuwe segmentatie",
    select_segments: "Selecteer segment",
    feed_messages: "Feedberichten",
    add_message: "Voeg bericht toe",
    message: "Bericht",
    publish_options: "Selecteer moment van publiceren",
    user_private_data: "Persoonlijke gegevens van gebruikers",
    add_new_public_page: "Voeg een facebook pagina toe",
    get_events_from: "Selecteer datum voor eerste post",
    days_before_or_event_trashold: "Aantal dagen voor...",
    facebook_app_does_not_exists: "Facebook-app bestaat niet",
    co2_usage: "CO2 uitstoot",
    cms_push_notification_publish_now_note:
      "Als tijdstip van publiceren gelijk of eerder is dan huidige tijdstip, dan wordt het bericht direct verstuurd. Let op: Het duurt minimaal 5 min. voordat het bericht verstuurd wordt naar de gebruikers.",
    speeding_more_than_x_percent: "Meer dan 20% boven snelheidslimiet",
    event: "Tankbeurt",
    co2: "CO2",
    search_location_on_map_or_poi: "Zoek op locatie of Nuttige Plaats",
    processing_refresh_page_in_a_couple_of_minutes:
      "Aan het verwerken. Ververs de pagina na enkele minuten.",
    set_trip_always_to_business: "Zet rit altijd op zakelijk",
    search_by_vehicle_details_or_driver: "Zoek op berijder, auto of kenteken",
    delete_feed_message: "Verwijder feedbericht",
    minutes: "minuut",
    low_battery_voltage: "Lage accuspanning",
    max_odometer: "Max. kilometerstand",
    min_odometer: "Min. kilometerstand",
    between: "Tussen",
    days_before: "Aantal dagen voor...",
    push_notifications: "Pushberichten",
    main_picture: "Afbeelding",
    publish_when: "Publiceer wanneer...",
    publish_at: "Publiceer op",
    send_to_selected: "Stuur naar segment",
    vehicle_make: "Merk",
    app_id: "Facebook app ID",
    vehicles_view: "De gebruiker kan alle voertuigen bekijken.",
    vehicles_edit: "De gebruiker kan alle voertuigen bekijken en aanpassen.",
    services_view:
      "De gebruiker kan informatie over voertuigonderhoud bekijken.",
    user_has_no_permission_over_objects:
      "De gebruiker heeft geen rechten tot deze optie.",
    devices_edit: "De gebruiker kan alle dongels zien en aanpassen.",
    devices_admin:
      "De gebruiker kan alle dongels zien, aanpassen en nieuwe dongels toevoegen.",
    services_edit:
      "De gebruiker kan informatie over voertuigonderhoud bekijken en aanpassen.",
    services_owner:
      "De gebruiker kan informatie over voertuigonderhoud bekijken, aanpassen en toevoegen.",
    points_of_interest_view:
      "De gebruiker kan de ingestelde Nuttige plaatsen bekijken.",
    points_of_interest_edit:
      "De gebruiker kan de ingestelde Nuttige plaatsen aanpassen.",
    points_of_interest_owner:
      "De gebruiker kan de ingestelde Nuttige plaatsen bekijken, aanpassen en verwijderen, en nieuwe Nuttige plaatsen aanmaken.",
    trips_view: "De gebruiker kan alle ritten bekijken.",
    devices_view: "De gebruiker kan alle dongels bekijken.",
    company_users_view: "De gebruiker kan alle berijders bekijken.",
    company_users_edit:
      "De gebruiker kan alle berijders bekijken en aanpassen.",
    notifications_admin:
      "De gebruiker kan alle meldingen bekijken en instellen welke meldingen weergegeven worden.",
    edit_vehicles: "De gebruikers kan alle voertuigen bekijken en aanpassen.",
    edit_feed_message: "Wijzig feedbericht",
    please_add_a_message: "Voeg een bericht toe",
    publish_now: "Publiceer nu",
    optional: "optioneel",
    request: "Request",
    request_fieldtracker: "Request fieldtracker",
    fieldtracker_service: "Fieldtracker service",
    geofence_created: "Geofence gemaakt",
    point_of_interest_created: "Nuttige Plaats aangemaakt",
    create_geofence: "Geofence aanmaken",
    vehicle_leaves_geofence: "Notificatie bij verlaten van de geofence",
    greater_than_or_equal_to: "Moet groter of gelijk zijn aan 0",
    back_to_reports: "Terug naar rapportages",
    parking_no_device_30_minutes: "Meld elke 30 minuten wanneer geparkeerd",
    find_hotspot: "Vind hotspot",
    company_users_owner:
      "De gebruiker kan alle berijders bekijken, aanpassen en verwijderen, en nieuwe berijders toevoegen.",
    notifications_view: "De gebruiker kan alle meldingen bekijken.",
    edit_services:
      "De gebruiker kan informatie over voertuigonderhoud bekijken en aanpassen.",
    edit_companies: "De gebruiker kan bedrijfsgegevens bekijken en aanpassen.",
    edit_devices: "De gebruiker kan alle dongels bekijken en aanpassen.",
    edit_trips: "De gebruiker kan alle ritten bekijken en aanpassen.",
    edit_company: "De gebruiker kan de bedrijfsgegevens bekijken en aanpassen.",
    count: "Aantal",
    feed_objec_publish_now_note:
      "Als tijdstip van publiceren gelijk of eerder is dan huidige tijdstip, dan wordt het bericht direct gepost. Let op: Het duurt minimaal 5 min. voordat het bericht zichtbaar is in een app.",
    vehicle_year: "Bouwjaar",
    max_year: "Max. bouwjaar",
    add_segment: "Voeg segment toe",
    apk_expires: "Afloop APK",
    vehicle_service: "Volgend onderhoud",
    segments: "Segmentatie",
    add_public_facebook_page: "Voeg facebook pagina toe",
    image: "Afbeelding",
    image_file_size: "Formaat afbeelding",
    publish_on: "Publiceer op...",
    published_by: "Gepubliceerd door",
    weekends: "Ook tijdens het weekend",
    from: "Start werkdag",
    select_kpi_want_to_see:
      "Selecteer de KPI's die je wilt zien (selectie van meerdere opties is mogelijk).",
    max_12_columns: "Je kunt maximaal 7 KPI's selecteren.",
    first_data_at: "Eerste data registratie op",
    driving_scores: "Rijscore",
    vehicle_inspection: "Afloop APK",
    error_codes: "Foutcodes",
    no_segment_selected: "Geen segment geselecteerd",
    to: "Einde werkdag",
    update_account_to_create_right: "Update payment details to start parking",
    vehicle_enters_geofence: "Notificatie bij aankomst in geofence",
    type: "Type",
    driver_name: "Naam (bestuurder)",
    vehicle_inspection_data: "Afloop APK",
    send_to_all: "Verstuur naar iedereen",
    display_vehicle_inspection: "Afloop APK",
    last_service: "Vorige onderhoudsbeurt",
    add_new_feed_message: "Voeg nieuw feedbericht toe",
    undefined: "Undefined",
    private_distance: "Afstand (privé)",
    total_business_distance: "Totale afstand (zakelijk)",
    average_co2_emission_per_trip: "Rit (gem. CO2 uitstoot)",
    scroll_to_load_more: "Scroll omlaag om meer te laden",
    scroll_down_or_click_to_load_more: "Scroll omlaag of klik om meer te laden",
    trip_started_at: "Rit gestart op",
    vehicle_driving_or_trip_still_active_cant_disconnect:
      "Voertuig rijdt nog en de trip is nog steeds actief. Kan niet loskoppelen op dit moment.",
    available: "Verbergen op kaart",
    loading: "Laden...",
    max_parking_until: "Max parkeren tot %{end_time}",
    unavailable: "Tonen op kaart",
    average_speed_over_limit: "Gem. snelheid te hard gereden",
    parking: "Parkeren",
    dot: "Verberg label",
    fuel_events: "Tanken",
    max_speed_over_limit: "Hoogste snelheid (vs. toegestaan)",
    hide_details: "Verberg details",
    parking_type: "Parkeer modus",
    platform: "Platform",
    business_distance: "Afstand (zakelijk)",
    trip_usage_per_100: "Verbruik per 100 km",
    no_mobile_device: "No mobile device",
    wrong_email_or_password: "Verkeerde email of wachtwoord",
    no_more: "Er valt niets meer te laden...",
    non_active: "Non active",
    average_over_limit_speed: "Gem. snelheid te hard gereden",
    speeding: "Snelheid",
    find_a_conversation: "Zoek een bericht",
    own_contribution: "Eigen bijdrage",
    faq_23_description:
      "Houd de OBD-aansluiting van de auto indien mogelijk tegen met je hand en beweeg de dongel voorzichtig heen en weer terwijl je hem in zijn geheel uit de aansluiting trekt. Let op: de aansluiting past precies en je moet dan vaak ook even kracht zetten om de dongel eruit te trekken.",
    out_of_country: "Auto in het buitenland",
    additional_user_info: "Voeg extra informatie toe",
    user_part_of_another_fleet_contact_support:
      "Deze gebruiker is deel van een ander wagenpark. Neem contact op met support voor een oplossing",
    driver_description_text:
      "De berijder krijgt een uitnodiging om toegevoegd te worden aan jouw wagenpark. De berijder krijgt ook een eigen dashboard en kan de app gebruiken. Zo krijgt de berijder toegang tot voertuig informatie en de ritten registratie. Daarnaast kan de berijder de privacy instellingen wijzigen, waardoor sommige informatie niet meer zichtbaar is voor de wagenparkbeheerder. Als de berijder al een account heeft, typ dan het emailadres in. Dan vullen wij alvast alle gegevens in die wij hebben.",
    welcome_to_ulu: "Welkom!",
    advanced_settings: "Instellingen",
    customize_for_vehicle: "Stel in per voertuig",
    custom_email_for_notifications: "Voeg emailadressen toe voor notificaties",
    parkings: "Parkeeracties",
    company_edit: "Aanpassen",
    user_input: "Handmatige aanpassing",
    odometer_history: "Geschiedenis kilometerstand",
    driving_behaviour: "Rijgedrag",
    trips_number: "Ritten",
    idle_score: "Stationair",
    parking_no_vat_added: "Straatparkeren - btw vrijgesteld",
    transactions: "Transacties",
    transaction_costs: "Transactiekosten",
    bill_to: "Rekening naar",
    trips_no: "Totaal aantal ritten",
    with: "met",
    new_conversation: "Nieuw bericht",
    speeding_percent_over_limit: "% te hard gereden",
    create_conversation: "Maak een nieuw bericht",
    conversations: "Berichten",
    conversation_id: "Berichten",
    energy_label: "Energielabel",
    parked_since: "Geparkeerd",
    since: "Sinds",
    content: "Type jouw bericht...",
    "27_hours_no_data": "Auto 72 uur niet gebruikt",
    max_duration_right: "Maximale parkeertijd",
    ps_rights_max_duration: "Maximale parkeertijd in zone",
    allow_representative_to_view_dashboard_text:
      "Geef Support toegang tot jouw dashboard",
    catalogue_price: "Fiscale waarde",
    license_plate_date: "Datum eerste toelating",
    catalogue_owner_type: "Type eigenaar",
    send: "Verstuur",
    user_help_privacy_description:
      'ULU vindt jouw privacy ontzettend belangrijk en heeft dan ook een aantal stappen genomen om deze te borgen. Het registreren van ritten raakt vrijwel altijd de Wet bescherming Persoonsgegevens. Daarom is het van belang om een ritregistratiesysteem te kiezen met het keurmerk Keurmerk RitRegistratieSystemen. Deze zijn door de stichting grondig gekeurd op het gebruik van data / gegevens en het veiligstellen / waarborgen van jouw privacy. Een systeem zoals ULU dus! </br></br> ULU verzameld miljoenen (misschien wel miljarden!) data van iedereen die met ULU rijdt. Wij gaan zorgvuldig met de gegevens om en zorgen voor een ijzersterke / niet te kraken beveiliging van deze data, en voldoen 100% aan alle betreffende wet- en regelgeving. Geen zorgen wij respecteren altijd jouw privacy. Daarom streven wij volledig de Privacy Gedragscode Keurmerk RitRegistratieSystemen na. Op die manier voldoet zowel jouw werkgever als jij zelf aan de “ Privacy Gedragscode”. </br></br> “De wat en welke code?” Geen zorgen, ULU legt het je uit. De Privacy Gedragscode zorgt er simpelweg voor dat jouw privacy gewaarborgd wordt. Zo zorgen wij ervoor als jij de ritmodus op privé zet, niemand anders ziet waar jij op dat moment bent, naar toe rijdt of bent geweest. Je mag namelijk 500 kilometer privé rijden, zonder dat je bijtelling hoeft te betalen! Dat is op en neer van Amsterdam naar Antwerpen of een enkele reis naar Parijs! Ook kun je een aantal keer je kinderen naar school brengen of ophalen van sport. Al jouw privé kilometers (<500 kilometer per jaar) gaat natuurlijk niemand wat aan! </br></br> De Stichting Keurmerk RitRegistratieSystemen heeft een Privacy Gedragscode opgesteld en ingediend bij College Bescherming Persoonsgegevens met als onderdeel een bijbehorende beroepscommissie. Deze beroepscommissie behandelt en onderzoekt alle klachten. Jij als ULU ‘er kunt hier altijd terecht. </br></br> Respecteer deze code, en je houdt je gelijk aan de wet- en regelgeving rondom Wet bescherming Persoonsgegevens. Klik <a href="https://www.keurmerkritregistratiesystemen.nl/privacy/gedragscode">hier</a> voor meer informatie over de Privacy Gedragscode.',
    email_monthly_invoices: "Email maandelijkse facturen (parkeren)",
    contact_us_to_disable: "Neem contact met ons op om te activeren",
    generate_payment_link: "Genereer link",
    price_per_transaction: "€ 0,25 ex. BTW per parkeeractie",
    payment_is_setup: "Betaalmethode is ingesteld",
    send_link_to_email_and_setup_later:
      "Stuur link naar email om later in te stellen",
    setup_now: "Stel nu direct in",
    contact_us_to_enable: "Neem contact met ons op om in te schakelen",
    business_parking: "Zakelijk parkeren",
    monthly_invoice: "Maandelijkse factuur",
    offer: "Offerte",
    create_sms: "Maak SMS",
    destroy_sms: "Verwijder SMS",
    edit_geofences: "Bewerk geofences",
    custom_company_role: "Eigen bedrijfsrollen",
    view_sms: "Bekijk SMS",
    destroy_geofences: "Verwijder geofences",
    sms: "SMS",
    "one-off": "eenmalig",
    per_month: "per maand",
    create_geofences: "Maak geofence aan",
    role_successfully_created: "Rol succesvol gecreëerd ",
    view_geofences: "Bekijk geofences",
    send_reports: " Verstuur rapporten",
    edit_trip_notes: "Bewerk ritnotities",
    schedule_reports: "Plan rapporten",
    view_timeline: "Bekijk tijdslijn",
    edit_role: "Bewerk rol",
    role_successfully_updated: "Rol succesvol opgeslagen",
    create_new_role: "Maak nieuwe rol aan",
    default_role: "Standaard rol",
    default: "Standaard",
    add_new_role: "Voeg nieuwe rol toe",
    roles: "Rollen",
    start_time_first_trip: "Tijd (start eerst rit)",
    tuesday_short_2: "Di ",
    check_out_your_scores: "Bekijk jouw scores",
    heading_in_dashboard: "Rij-richting in dashboard",
    vehicle_heading_on_dashboard: "Rij-richting in dashboard",
    maintenance: "Onderhoud",
    number_of_devices: "Aantal dongels",
    automatic_incasso_invoice_description:
      "Wij zullen het factuurbedrag binnen 5 werkdagen afschrijven van de door jouw opgegeven bankrekening",
    scheduled_maintainance_delay:
      "Op dit moment voeren wij wat onderhoudswerkzaamheden uit op onze portal. Excuses voor het ongemak. Het kan zijn dat je op dit moment niet alle ritten kan zien of dat jouw device foutmelding geeft. Wij werken zo hard mogelijk om de werkzaamheden zo snel mogelijk af te ronden",
    group_not_found: "Groep niet gevonden",
    invoice_date: "Factuurdatum",
    amount_due: "Te betalen",
    payment_due: "Vervaldatum",
    invoice_number: "Factuurnummer",
    user_not_part_of_the_company: "Berijder is niet deel van het bedrijf",
    driver_in_group: "Voeg berijder ook toe in groep",
    vehicle_in_group: "Voeg voertuig ook toe in groep",
    payment_type: "Betalingswijze",
    product: "Product",
    quantity: "Hoeveelheid",
    price_ex_vat: "Prijs ex. BTW",
    vat_21_percent: "BTW 21%",
    total: "Totaal",
    ulu_terms_and_conditions_apply: "ULU-voorwaarden zijn van toepassing.",
    bank_account: "Bankrekening",
    credit_invoice: "Kredietfactuur",
    invoices: "Facturen",
    bic: "BIC",
    iban: "IBAN",
    kvk: "KVK",
    payment_on_using: "Payment on %{paid_at} using a %{payment_type}",
    parking_costs: "Parkeerkosten",
    service_costs: "Service kosten",
    invoice_id: "Factuur",
    invoice: "Factuur",
    setup_per_vehicle: "Setup per voertuig",
    manually_setup_vehicles: "Stel in per voertuig",
    permitted_for_all_vehicles: "Alle voertuigen",
    addition: "Bijtelling",
    weekdays: "Doordeweeks",
    full_week: "Hele week",
    weekend: "Weekend",
    selected: "Geselecteerd",
    average_fuel_consumption: "Gem. brandstofverbruik (fabriek)",
    time_frame: "Schema",
    outside_of_scheduled_times: "Valt buiten ingestelde tijd",
    edit_schedule: "Wijzig planning",
    overlapping_with_another_interval:
      "Er is een overlap met een andere planning",
    valid_for_all_vehicles: "Geldig voor alle voertuigen",
    monday: "Maandag",
    not_scheduled_description:
      "Deze instelling zorgt ervoor dat alle ritten die buiten reeds geplande schema's vallen, deze ritmodus krijgen.",
    create_new_schedule: "Voeg nieuw schema toe",
    average_co2: "Gem. CO2 uitstoot (fabriek)",
    add_new_schedule: "Voeg nieuw schema toe",
    view_all_vehicles: "Alle voertuigen",
    select_all_vehicles: "Selecteer alle voertuigen",
    update: "Bijwerken",
    tuesday: "Dinsdag",
    wednesday: "Woensdag",
    thursday: "Donderdag",
    friday: "Vrijdag",
    saturday: "Zaterdag",
    sunday: "Zondag",
    not_scheduled: "Nog niet ingepland",
    for: "Voor",
    no_more_dongles_third_party:
      "Er zijn geen dongles meer die aan de derde partij kunnen worden toegewezen. Neem contact op met %{link} om meer dongles te bestellen.",
    connected_to_vehicle: "Verbonden met voertuig",
    no_app_access: "geen app-toegang",
    user_has_no_access_to_web_and_mobile_apps:
      "Gebruiker heeft geen toegang tot internet en mobiele apps",
    invite_new_driver: "nodig een nieuwe bestuurder uit",
    or: "or",
    from_current_company: "van het huidige bedrijf",
    select_driver: "selecteer bestuurder",
    select_user: "selecteer gebruiker",
    co2_emissions: "Rit (CO2 uitstoot)",
    start_at: "Rit start (datum + tijd)",
    stop_at: "Rit stop (datum + tijd)",
    odometer_start: "Kilometerstand (start)",
    start_time: "Rit start (tijd)",
    stop_time: "Rit stop (tijd)",
    fuel_average: "Tanken (gem.)",
    deselect_all: "Alles deselecteren",
    missing_phone_number: "We missen jouw telefoonnummer",
    code_not_valid: "Tikfoutje? De code klopt namelijk niet...",
    select_all: "Alles selecteren",
    csv: "CSV",
    acceleration_score: "Score (acceleratie)",
    date_range: "Periode",
    save_selection: "Bewaar selectie",
    speeding_score: "Score (snelheid)",
    braking_score: "Score (remmen)",
    owner_type: "Eigenaarstype",
    fuel_costs: "Tanken (kosten)",
    start_hotspot_id: "POI begin",
    based_on: "Gebaseerd op",
    fuel_quantity: "Tanken (hoeveelheid)",
    fuel_price_per_liter: "Tanken (prijs per liter)",
    export_history: "Export geschiedenis",
    last_7_days: "Afgelopen 7 dagen",
    time_driven: "Tijd (rijdend)",
    user_name_not_present: "Gebruikersnaam niet bekend",
    create_new_ibutton: "Voeg nieuwe iButton toe",
    payment_term: "Betaaltermijn",
    send_app: "Verstuur App",
    start_hotspot: "POI (start)",
    summary: "Totalen",
    static_period: "Vaste periode",
    daily: "Dagelijks",
    fuel_location: "Tanken (locatie)",
    export: "Exporteren",
    monday_short_2: "Ma ",
    duration: "Tijd (totaal rit)",
    report_is_being_generated_description:
      "De rapportage wordt gegenereerd. Dit duurt wat langer, wacht er maar niet op! Je krijgt een mailtje als de rapportage klaar staat!",
    trip_split_interval: "Dynamische rit interval",
    format: "Formaat",
    emission_code: "Emission code",
    web_and_mobile_access: "Geeft gebruiker toegang tot web en app",
    user_without_mobile_and_web_access_description:
      "De gebruiker heeft geen toegang tot de app en webportal, maar kan worden gebruikt in rapporten en toegewezen worden als bestuurder.",
    trip_user_permission: "Rechten voor ritten",
    offer_disclaimer:
      "Alle diensten, contracten, aanbiedingen en andere overeenkomsten zijn onderworpen aan onze Algemene voorwaarden",
    vat_reverse_charge: "Omgekeerde BTW lading",
    create_point_of_interest: "Nuttige plaats aanmaken",
    stop_hotspot_id: "POI (stop)",
    current_month: "Huidige maand",
    odometer_value: "Kilometerstand",
    start_address: "Adres (start)",
    friday_short_2: "Vr",
    sunday_short_2: "Zo",
    this_month: "Huidige maand",
    no_data_for_selection: "No data for selection",
    add_new_ibutton: "Voeg nieuwe iButton toe",
    edit_ibutton: "Wijzig iButton",
    open: "Open",
    type_to_search: "Zoek...",
    all_orders: "Alle orders",
    discount_per_item: "Korting per stuk",
    price_once: "Eenmalig",
    price_monthly: "Maandelijkse prijs",
    item: "Item",
    category: "Category",
    tab: "Tab",
    are_you_chris_sure: "Would this inquiry make Christian proud?",
    add_item: "Voeg item toe",
    finalize: "Opslaan",
    set_starting_date: "Start datum...",
    retroactive_invoicing: "Facturatie achteraf",
    retroactive_invoicing_description: "Facturen worden verzonden aan het einde van elke factureringsperiode - 5 dagen in plaats van aan het begin (bijv. factuur verzonden op 26 dec voor periode 1 okt - 31 dec)",
    next: "Volgende",
    contact: "Contact",
    signout: "Uitloggen",
    system: "Systeem",
    lang: "Taal",
    new_customer: "Nieuwe klant",
    orders: "Orders",
    billing: "Muney",
    otp_code_message:
      "Hi, dit is jouw code om in te loggen in de Cartracker / ULU portal: %{code}. Deze code is 5 minuten geldig. Geniet van jouw dag!",
    two_factor_authentication: "Two Factor Authentication",
    remember_me: "Vergeet mij niet :(",
    enable_two_factor_autentication:
      "Two Factor Authentication bij inloggen inschakelen",
    phone_number_not_valid: "Telefoonnummer werkt niet",
    code_sent: "Jahoor, check jouw telefoon (code verstuurd)",
    create_new_rule: "Maak nieuwe regel aan",
    edit_rule: "Wijzig regel",
    hotspot_privacy_rules: "Nuttige plaatsen",
    set_trip_privacy: "Automatiseer ritmodus",
    none: "Geen",
    both:
      "Beide, maar: Nuttige Plaatsen zijn belangrijker dan Privacy schema's",
    based_on_schedule: "Gebruik alleen privacy schema's",
    based_on_poi: "Gebruik alleen nuttige plaatsen",
    schedule: "Privacy schema's",
    dont_forget_to_update_your_phone_number:
      "Let op: Voor 2FA moet je wel een geldig telefoonnummer invullen (anders kan je niet meer inloggen)! Klik <a href=%{url}>hier</a> om jouw profiel te updaten.",
    valid_for_selected_vehicles: "Geldig voor alle voertuigen",
    stop_hotspot: "POI (stop)",
    sliding_window: "Dynamische periode",
    previous_day: "Vorige dag",
    fuel_transaction_at: "Tanken (datum + tijd)",
    note: "Notities",
    time_idle: "Tijd (stationair)",
    thursday_short_2: "Do",
    wednesday_short_2: "Wo",
    yesterday: "Gisteren",
    in_seconds: "in seconden",
    find_ibutton_or_user: "Zoek iButton of bestuurder",
    months: "Maanden",
    ibutton: "iButton",
    user_phone_number_not_valid: "Telefoonnummer niet geldig...",
    destination: "Bestemming",
    departure: "Vertrek",
    add_new_rule: "Voeg nieuwe regel toe",
    create_new_report_schedule: "Maak nieuw rapportage schema aan",
    edit_report_schedule: "Wijzig rapportage schema",
    create_new_report: "Bewaar als nieuw standaard rapportage",
    number_of_days: "Aantal dagen",
    from_day_of_month: "Vanaf dag van de maand",
    period: "Periode",
    filter_period: "Filter periode",
    report_schedules: "Rapportage schema's",
    template: "Template",
    every_day: "Dagelijks",
    weekly: "Wekelijks",
    monthly: "Maandelijks",
    yearly: "Jaarlijks",
    add_new_report_schedule: "Voeg nieuw rapportage schema toe",
    day_of_year: "Dag van het jaar",
    day_of_month: "Dag van de maand",
    day_of_week: "Dag van de week",
    frequency: "Frequentie",
    report_template: "Rapportage template",
    emails: "E-mail adressen",
    current_day: "Huidige dag",
    average_co2_emission: "CO2 (gem. uitstoot)",
    stop_address: "Adres (stop)",
    end_time_last_trip: "Tijd (stop laatste rit)",
    edit_columns: "Wijzig kolommen",
    saturday_short_2: "Za",
    last_month: "Vorige maand",
    last_30_days: "Afgelopen 30 dagen",
    today: "Vandaag",
    live_view_refresh_rate: "Live view refresh interval",
    name_missing: "Naam ontbreekt",
    number: "Nummer",
    price_per_piece: "Prijs per stuk",
    send_sms: "Verstuur SMS",
    trips_edit: "Wijzigen",
    select_customer: "Selecteer klant",
    first_name: "Voornaam",
    existing_inquiries: "Bestaande offertes",
    enter_notes: "Voeg aantekeningen toe",
    last_name: "Achternaam",
    name_type: "Naam / Type",
    shipping_information: "Verzendadres",
    billing_information: "Factuur informatie",
    customer_information: "Contact informatie",
    grand_total: "Totaal",
    initial_payment: "Eerste betaling",
    payments: "Betalingen",
    payment_method: "Betaalmethode",
    add_new: "Voeg nieuwe toe",
    new_inquiry: "Nieuwe offerte",
    customers: "Klanten",
    customer: "Klanten",
    price_list: "Prijslijst",
    inquiries: "Offertes",
    signature: "Handtekening",
    lets_get_started: "Hoppa, let's go!",
    total_per_year: "Totaal per jaar",
    total_one_off: "Totaal eenmalig",
    per_payment: "Per betaling",
    one_time: "eenmalig",
    one_off: "Eenmalig",
    discount_per_piece: "Korting / stuk",
    payment_condition: "Betaalcondities",
    start_date: "Start datum",
    contract_duration: "Contract duur",
    consultant: "Consultant",
    start_date_at: "Start rit (datum)",
    stop_time_at: "Stop rit (tijd)",
    start_time_at: "Start rit (tijd)",
    stop_date_at: "Stop rit (datum)",
    accepted_at: "Geaccepteerd bij",
    accepted_inquiries: "Geaccepteerde aanvragen",
    terms_version: "Versie voorwaarden",
    signed_by: "Ondertekend door",
    has_signed_pdf: "Ondertekende PDF",
    total_price_one_time: "Totaal eenmalig",
    total_price_per_month: "Totaal per maand",
    webapp_registration: "Webapp registratie",
    re_send_registration_email: "Resend registration email",
    disable_sending_invoices: "Disable sending invoices",
    enable_sending_invoices: "Enable sending invoices",
    price_list: "Prijslijst",
    scheduled_termination_at: "Beëindiging gepland op",
    terminate_scheduled_by_customer: "Beëindiging gepland door klant",

    terminations: "Beëindigingen",
    all_terminations: "Alle beëindigingen",
    kill_list: "Kill list",
    reference: "Referentie",
    process_type: "Type verwerking",
    return_process: "Retourverwerking",
    terminate_at: "Beëindig op",
    ft_status: "Fieldtracker status",
    terminations_by_myenv: "Beëindigingen door MyEnvo",
    
    add_photo: "Voeg foto toe",
    title: "Titel",
    you_are_adding: "Je bent aan het toevoegen",
    you_are_removing: "Je bent aan het verwijderen",

    undo: "Ongedaan maken",
    confirm_undo_termination: "Weet u zeker dat u de beëindiging door de klant wilt ongedaan maken?",
    this_week: "Deze week",
    discount_applied: "Korting toegepast",

    prefill_data: "Vooraf ingevuld",
    select_device_type: "Selecteer apparaattype",
    select_task: "Selecteer taak",
    select_ft_task: "Selecteer Fieldtracker taak",
    select_license_plate_identifier: "Selecteer kenteken identifier",
    select_imei_identifier: "Selecteer IMEI identifier",

    product:"Product",
    requesters: "Opdrachtgevers",
    pending_services: "In afwachting van goedkeuring",
    removed: "Verwijderd",
    expired: "Verlopen",

    cannot_delete_order_with_requested_synatec_orders: "Je kunt geen hard delete uitvoeren omdat er een Sinatec-order in behandeling is.",
    employed: "In dienst",
    not_employed: "Niet in dienst",
    displayed: "Weergegeven",
    not_displayed: "Niet weergegeven",

    found: "Gevonden",
    not_found: "Niet gevonden",
    match: "Overeenkomend",
    no_match: "Niet overeenkomend",
    blocked_devices_for_pending_termination: "Geblokkeerd apparaat/apparaten wegens lopende beëindiging",

    shipping_fee: "Verzendkosten",
    set_shipping_fee: "Instellen als verzendkosten",
    remove: "Verwijderen",

    last_device: "Laatste apparaat",
    has_not_paid_invoices: "Heeft niet betaalde facturen",
    awaiting_penalty_payment: "In afwachting van betaling van de boete",
    payments_up_to_date: "Betalingen up-to-date",

    my_environment_exceptions: "MyEnvironment uitzonderingen",
    payments_up_to_date: "Betalingen up-to-date",

    order_include_item: "Bestelling bevat item",
    specific_item_included: "Specifiek item inbegrepen in bestelling",
    optional: "Optioneel",
  },
  
  system_restriction: {
    title: "Dit record hoort bij een ander systeem",
    description: "Schakel over naar het systeem van dit record om de informatie te bekijken.",
    current_system: "Huidig systeem",
    record_system: "Systeem van record",
    switch_to: "Overschakelen naar {system}",
    go_back: "Terug",
    no_access_title: "Geen toegang",
    no_access_description: "Je hebt geen toegang tot het {system} systeem.",
  },
  fleet: {
    owner: "Eigenaar",
    paying_entity: "Betalende entiteit",
    vehicle: "Voertuig",
    billing: "Billing",
    show_fleet_devices: "Toon apparaten in Fleet",
    show_billing_devices: "Toon apparaten in Billing",
    not_in_fleet: "Niet in Fleet",
    not_in_billing: "Niet in Billing",
    billing_lookup_failed: "Kon Billing niet controleren",
    fleet_lookup_failed: "Kon Fleet niet controleren",
    retry: "Opnieuw proberen",
    no_web_app_id: "Klant zonder web app ID",
    different_customer: "Andere klant",
    unpaired: "Niet gekoppeld",
    different_owner_or_paying_entity: "Andere eigenaar of betalende entiteit",
  },
  fieldtracker: {
    request_service: "Request Fieldtracker Service",
    task_type: "Task",
    save_and_notify: "Opslaan en email klant",
    save_and_dont_notify: "Opslaan en email klant niet",
    requester_name: "In opdracht van",
    use_hq_as_default: "Gebruik ULU Locatie als standaard optie",
    send_sms: "Verstuur SMS",
    device_type: "Apparaattype",
    task: "Taak",
    api_identifier: "API Identifier",
    license_plate_identifier: "Kenteken identifier",
    imei_identifier: "IMEI identifier",
  },
  webshop:{
    position: "Positie",
    move_up: "Omhoog verplaatsen",
    move_down: "Omlaag verplaatsen",
    set_position: "Stel positie in",
  }
};
